<template>
  <div class="lg:px-40 md:px-24 px-5 profession">
    <div class="bg-713e652b">
      <div class="lg:py-12 md:py-12 py-6 lg:px-16 md:px-16 px-5">
        <p class="fsize18 text-center text-gray lg:w-10/12 mx-auto">
          Please fill out the form below with your requirements, and someone
          from our team will contact you for further assistance.
        </p>
        <ValidationObserver
          tag="form"
          ref="obs1"
          class="h-100"
          @submit.prevent="addFunc()"
        >
          <div
            class="grid lg:grid-cols-2 md:grid-cols-2 grid-cols-1 lg:gap-4 md:gap-4 mt-4"
          >
            <div class="">
              <p class="input-title textcolor text-primary">
                Name
                <span class="text-danger">*</span>
              </p>
              <ValidationProvider name="fullName" rules="required|alphabetOnly">
                <base-input
                  v-model="fullName"
                  placeholder="Enter Your Name "
                  class="md:border-0 lg:border-0 custipshadow"
                  :rules="{ required: true, alphabetOnly: true }"
                  name="Name"
                ></base-input>
                <!-- <span class="fsize12 text-danger">{{ errors[0] }}122333</span> -->
              </ValidationProvider>
            </div>

            <div class="">
              <p class="input-title textcolor text-primary">
                Email Address
                <span class="text-danger">*</span>
              </p>
              <ValidationProvider name="emailAddress" v-slot="{ errors }">
                <base-input
                  v-model="emailAddress"
                  placeholder="Enter Your Email"
                  class="md:border-0 lg:border-0 custipshadow"
                  :rules="{ required: true, email: true }"
                  name="Email"
                ></base-input>
                <span class="fsize12 text-danger">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>

            <div class="">
              <p class="input-title textcolor text-primary">
                Phone Number
                <span class="text-danger">*</span>
              </p>
              <ValidationProvider name="Phone" v-slot="{ errors }">
                <base-input
                  v-model="phone"
                  placeholder="Enter Your Phone"
                  class="md:border-0 lg:border-0 custipshadow"
                  :rules="{ required: true, numeric: true, min: 10, max: 10 }"
                  name="Phone"
                ></base-input>
                <span class="fsize12 text-danger">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>

            <div class="">
              <p class="input-title textcolor text-primary">
                Location
                <span class="text-danger">*</span>
              </p>
              <ValidationProvider name="location" v-slot="{ errors }">
                <base-input
                  v-model="location"
                  placeholder="Enter Your Location"
                  :rules="{ required: true }"
                  class="md:border-0 lg:border-0 custipshadow"
                  name="Location"
                ></base-input>
                <span class="fsize12 text-danger">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>

            <div class="">
              <p class="input-title textcolor text-primary">
                What are you looking for?
                <span class="text-danger">*</span>
              </p>
              <ValidationProvider
                name="whatAreYouLookingFor"
                v-slot="{ errors }"
              >
                <b-form-select
                  :rules="{ required: true }"
                  v-model="whatAreYouLookingFor"
                  :options="options"
                  @change="clearForm()"
                ></b-form-select>
                <span class="fsize12 text-danger">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <!-- ---------------Request for Service-------------- -->
          <div
            class="mt-4 bg-white p-4 rounded-lg"
            v-if="whatAreYouLookingFor === 'Request for Service'"
          >
            <h4 class="fsize20 font-semibold text-primary">
              Request for Service
            </h4>
            <p class="fsize16 text-gray mt-1">
              Caregiver Saathi offers a range of services including personalized
              support for caregivers, expert consultations, informative
              resources, and community engagement opportunities, all tailored to
              empower and assist individuals navigating the challenges of
              caregiving. To know more
              <a
                class="text-primary underline"
                href="https://caregiversaathi.co.in/product-services"
                target="_blank"
                >https://caregiversaathi.co.in/product-services</a
              >
            </p>
            <div class="my-4 flex flex-wrap items-center gap-2">
              <div v-for="(i, index) in requestForServiceOptions" :key="index">
                <b-badge
                  variant="success"
                  v-if="requestForService.includes(i)"
                  @click="removeFromRequestForService(i)"
                  class="rounded-full px-4 pb-1 pt-2 cursor-pointer"
                  ><p class="fsize12">{{ i }}</p></b-badge
                >
                <b-badge
                  variant="light"
                  @click="addToRequestForService(i)"
                  v-else
                  class="rounded-full px-4 pb-1 pt-2 cursor-pointer"
                  ><p class="fsize12 text-dark">
                    {{ i }}
                  </p></b-badge
                >
              </div>
            </div>
          </div>

          <!-- ---------------Corporate Services/ Partnerships-------------- -->
          <div
            class="mt-4 bg-white p-4 rounded-lg"
            v-if="whatAreYouLookingFor === 'Corporate Service/ Partnership'"
          >
            <h4 class="fsize20 font-semibold text-primary">
              Corporate Services/ Partnerships
            </h4>
            <p class="fsize16 text-gray mt-1">
              Thank you for your interest in partnering with us. Kindly fill in
              the details below for us to better understand your organisation
              and your approach. We will get in touch with you at the earliest!
              <br />
              <span class="text-primary font-semibold">About Us:</span> At
              Caregiver Saathi, our corporate services and partnerships focus on
              empowering organizations to cultivate supportive environments for
              caregivers among their workforces. Through tailored programs and
              collaborations, we aim to enhance employee well-being,
              productivity, and retention by addressing caregiving challenges
              and promoting a culture of empathy and support. You can also be
              our CSR partner or run a volunteer programme at your organisation
            </p>
            <div
              class="my-4 grid lg:grid-cols-2 md:grid-cols-2 grid-cols-1 gap-2 items-start"
            >
              <div class="">
                <p class="input-title textcolor text-primary">
                  Organization Name
                </p>
                <base-input
                  v-model="organisationName"
                  placeholder="Type..."
                  class="md:border-0 lg:border-0 custipshadow"
                  name="Experience"
                ></base-input>
              </div>

              <div class="">
                <p class="input-title textcolor text-primary">
                  Your official e-mail ID
                </p>
                <base-input
                  v-model="officialEmail"
                  placeholder="Type..."
                  class="md:border-0 lg:border-0 custipshadow"
                  name="Location"
                ></base-input>
              </div>
              <div class="">
                <p class="input-title textcolor text-primary">
                  Designation/ Role
                </p>
                <base-input
                  v-model="designation"
                  placeholder="Type..."
                  class="md:border-0 lg:border-0 custipshadow"
                  name="Location"
                ></base-input>
              </div>
              <div class="">
                <p class="input-title textcolor text-primary">
                  Please tell us in brief about your organization
                </p>
                <base-input
                  v-model="pleaseTellUsInBriefAboutOrg"
                  placeholder="Type..."
                  class="md:border-0 lg:border-0 custipshadow"
                  name="Location"
                ></base-input>
              </div>
              <div class="">
                <p class="input-title textcolor text-primary">Website URL</p>
                <base-input
                  v-model="websiteUrl"
                  placeholder="Type..."
                  class="md:border-0 lg:border-0 custipshadow"
                  name="Location"
                ></base-input>
              </div>
              <div class="">
                <p class="text-primary">
                  In what capacity do you wish to partner with us?
                </p>
                <!-- <b-form-select
                v-model="inWhatCapacityDoYouWishToPartnerWithUs"
                :options="options2"
              ></b-form-select> -->
                <Multiselect
                  multiple
                  :options="options2"
                  v-model="inWhatCapacityDoYouWishToPartnerWithUs"
                />
              </div>
              <div class="">
                <p class="input-title textcolor text-primary">
                  What are your top 3 objectives in partnering with us
                </p>
                <base-input
                  v-model="whatAreYourTop3Obj"
                  placeholder="Type..."
                  class="md:border-0 lg:border-0 custipshadow"
                  name="Location"
                ></base-input>
              </div>
            </div>
          </div>

          <!-- ---------------Partner With Us-------------- -->
          <div
            class="mt-4 bg-white p-4 rounded-lg"
            v-if="whatAreYouLookingFor === 'Partner with Us'"
          >
            <h4 class="fsize20 font-semibold text-primary">Partner With Us</h4>
            <el-tabs v-model="activeName2" @tab-click="clearForm">
              <!--  Care Services-->
              <el-tab-pane label="Care Services" name="Care_Services">
                <p class="fsize16 text-gray mt-1">
                  Interested in partnering with us to offer caregiver services
                  and products? Fill out the form below to see if you're a fit
                  for our platform. We'll review your submission and get in
                  touch to discuss collaboration opportunities.
                  <br />
                  Thank you for your interest!
                </p>
                <div
                  class="my-4 grid lg:grid-cols-2 md:grid-cols-2 grid-cols-1 gap-2 items-start"
                >
                  <div class="">
                    <p class="input-title textcolor text-primary">
                      Company Name
                    </p>
                    <base-input
                      v-model="companyName_CARE"
                      placeholder="Type..."
                      class="md:border-0 lg:border-0 custipshadow"
                      name="Experience"
                    ></base-input>
                  </div>

                  <div class="">
                    <p class="input-title textcolor text-primary">
                      Company Address
                    </p>
                    <base-input
                      v-model="companyAddress_CARE"
                      placeholder="Type..."
                      class="md:border-0 lg:border-0 custipshadow"
                      name="Location"
                    ></base-input>
                  </div>
                  <div class="">
                    <p class="input-title textcolor text-primary">
                      Website URL of the company
                    </p>
                    <base-input
                      v-model="companyWebsiteUrl_CARE"
                      placeholder="Type..."
                      class="md:border-0 lg:border-0 custipshadow"
                      name="Location"
                    ></base-input>
                  </div>
                  <div class="">
                    <p class="input-title textcolor text-primary">
                      Social media profile URL
                    </p>
                    <base-input
                      v-model="socialMediaUrl_CARE"
                      placeholder="Type..."
                      class="md:border-0 lg:border-0 custipshadow"
                      name="Location"
                    ></base-input>
                  </div>
                  <div class="">
                    <p class="input-title textcolor text-primary">
                      Years in business
                    </p>
                    <base-input
                      v-model="yearsInBusiness_CARE"
                      placeholder="Type..."
                      class="md:border-0 lg:border-0 custipshadow"
                      name="Location"
                    ></base-input>
                  </div>
                  <div class="">
                    <p class="text-primary">
                      Type of services offered (select multiple if required)
                    </p>
                    <!-- <b-form-select v-model="typesOfServices_CARE" multiple>
                    <b-form-select-option
                      v-for="item in options3"
                      class="py-5"
                      :key="item.text"
                      :label="item.text"
                      :value="item.text"
                    >
                    </b-form-select-option
                  ></b-form-select> -->
                    <Multiselect
                      multiple
                      :options="options3"
                      v-model="typesOfServices_CARE"
                    />
                  </div>
                  <div class="">
                    <p class="input-title textcolor text-primary">
                      Any additional comments or questions. We'll get back to
                      you as soon as we can!
                    </p>
                    <base-input
                      v-model="additionalQuestions_CARE"
                      placeholder="Type..."
                      class="md:border-0 lg:border-0 custipshadow"
                      name="Location"
                    ></base-input>
                  </div>
                </div>
              </el-tab-pane>
              <!-- Products -->
              <el-tab-pane label="Products" name="Products">
                <p class="fsize16 text-gray mt-1">
                  Interested in partnering with us to offer caregiver services
                  and products? Fill out the form below to see if you're a fit
                  for our platform. We'll review your submission and get in
                  touch to discuss collaboration opportunities.
                  <br />
                  Thank you for your interest!
                </p>
                <div
                  class="my-4 grid lg:grid-cols-2 md:grid-cols-2 grid-cols-1 gap-2 items-start"
                >
                  <div class="">
                    <p class="input-title textcolor text-primary">
                      Company Name
                    </p>
                    <base-input
                      v-model="companyName_PROD"
                      placeholder="Type..."
                      class="md:border-0 lg:border-0 custipshadow"
                      name="Experience"
                    ></base-input>
                  </div>

                  <div class="">
                    <p class="input-title textcolor text-primary">
                      Company Address
                    </p>
                    <base-input
                      v-model="companyAddress_PROD"
                      placeholder="Type..."
                      class="md:border-0 lg:border-0 custipshadow"
                      name="Location"
                    ></base-input>
                  </div>
                  <div class="">
                    <p class="input-title textcolor text-primary">
                      Website URL of the company
                    </p>
                    <base-input
                      v-model="companyWebsiteUrl_PROD"
                      placeholder="Type..."
                      class="md:border-0 lg:border-0 custipshadow"
                      name="Location"
                    ></base-input>
                  </div>
                  <div class="">
                    <p class="input-title textcolor text-primary">
                      Social media profile URL
                    </p>
                    <base-input
                      v-model="socialMediaUrl_PROD"
                      placeholder="Type..."
                      class="md:border-0 lg:border-0 custipshadow"
                      name="Location"
                    ></base-input>
                  </div>
                  <div class="">
                    <p class="input-title textcolor text-primary">
                      Years in business
                    </p>
                    <base-input
                      v-model="yearsInBusiness_PROD"
                      placeholder="Type..."
                      class="md:border-0 lg:border-0 custipshadow"
                      name="Location"
                    ></base-input>
                  </div>
                  <div class="">
                    <p class="text-primary">
                      Type of products offered (select multiple if required)
                    </p>
                    <!-- <b-form-select
                    v-model="typesOfProducts_PROD"
                    :options="options6"
                  ></b-form-select> -->
                    <Multiselect
                      multiple
                      :options="options6"
                      v-model="typesOfProducts_PROD"
                    />
                  </div>
                  <div class="">
                    <p class="input-title textcolor text-primary">
                      Any additional comments or questions. We'll get back to
                      you as soon as we can!
                    </p>
                    <base-input
                      v-model="additionalQuestions_PROD"
                      placeholder="Type..."
                      class="md:border-0 lg:border-0 custipshadow"
                      name="Location"
                    ></base-input>
                  </div>
                </div>
              </el-tab-pane>
              <!-- Collaboration -->
              <el-tab-pane
                label="Collaboration- Institutions"
                name="Collaboration"
              >
                <p class="fsize16 text-gray mt-1">
                  Partner with Caregiver Saathi to amplify your impact in the
                  caregiving community through collaborative initiatives, joint
                  campaigns, content sharing, and advocacy efforts. Join us in
                  creating meaningful change and support for caregivers across
                  diverse platforms and channels
                  <br />
                  Kindly Fill in the form for us to explore more
                  <br />
                  Thank you for your interest!
                </p>
                <div
                  class="my-4 grid lg:grid-cols-2 md:grid-cols-2 grid-cols-1 gap-2 items-start"
                >
                  <div class="">
                    <p class="input-title textcolor text-primary">
                      Company Name
                    </p>
                    <base-input
                      v-model="companyName_COLLAB"
                      placeholder="Type..."
                      class="md:border-0 lg:border-0 custipshadow"
                      name="Experience"
                    ></base-input>
                  </div>

                  <div class="">
                    <p class="input-title textcolor text-primary">
                      Company Address
                    </p>
                    <base-input
                      v-model="companyAddress_COLLAB"
                      placeholder="Type..."
                      class="md:border-0 lg:border-0 custipshadow"
                      name="Location"
                    ></base-input>
                  </div>
                  <div class="">
                    <p class="input-title textcolor text-primary">
                      Website URL of the company
                    </p>
                    <base-input
                      v-model="companyWebsiteUrl_COLLAB"
                      placeholder="Type..."
                      class="md:border-0 lg:border-0 custipshadow"
                      name="Location"
                    ></base-input>
                  </div>
                  <div class="">
                    <p class="input-title textcolor text-primary">
                      Social media profile URL
                    </p>
                    <base-input
                      v-model="socialMediaUrl_COLLAB"
                      placeholder="Type..."
                      class="md:border-0 lg:border-0 custipshadow"
                      name="Location"
                    ></base-input>
                  </div>
                  <div class="">
                    <p class="input-title textcolor text-primary">
                      Years in business
                    </p>
                    <base-input
                      v-model="yearsInBusiness_COLLAB"
                      placeholder="Type..."
                      class="md:border-0 lg:border-0 custipshadow"
                      name="Location"
                    ></base-input>
                  </div>
                  <div class="">
                    <p class="text-primary fsize14">
                      Type of Collaboration (pls select the areas in which you
                      want to partner)
                    </p>
                    <!-- <b-form-select
                    class="mt-1"
                    v-model="typesOfCollaboration_COLLAB"
                    :options="options7"
                  ></b-form-select> -->
                    <Multiselect
                      :options="options7"
                      v-model="typesOfCollaboration_COLLAB"
                    />
                  </div>
                  <div class="">
                    <p class="input-title textcolor text-primary">
                      Any additional comments or questions. We'll get back to
                      you as soon as we can!
                    </p>
                    <base-input
                      v-model="additionalQuestions_COLLAB"
                      placeholder="Type..."
                      class="md:border-0 lg:border-0 custipshadow"
                      name="Location"
                    ></base-input>
                  </div>
                </div>
              </el-tab-pane>
              <!--  Care Attendent-->
              <el-tab-pane label="Care Attendant" name="Care_Attendant">
                <p class="fsize16 text-gray mt-1">
                  Partner with Caregiver Saathi as a care attendant to expand
                  your reach and connect with individuals in need of caregiving
                  support. Join our network to offer your expertise, compassion,
                  and assistance to caregivers and their loved ones, making a
                  meaningful difference in their lives.
                </p>
                <div
                  class="my-4 grid lg:grid-cols-2 md:grid-cols-2 grid-cols-1 gap-2 items-start"
                >
                  <div class="">
                    <p class="input-title textcolor text-primary">
                      Number of years in the professions
                    </p>
                    <base-input
                      v-model="numofYearsInProfessions"
                      placeholder="Type..."
                      class="md:border-0 lg:border-0 custipshadow"
                      name="Experience"
                    ></base-input>
                  </div>

                  <div class="">
                    <p class="input-title textcolor text-primary">
                      Current City
                    </p>
                    <base-input
                      v-model="currentCity"
                      placeholder="Type..."
                      class="md:border-0 lg:border-0 custipshadow"
                      name="Location"
                    ></base-input>
                  </div>
                  <div class="">
                    <p class="input-title textcolor text-primary">
                      Why do you want to partner with Caregiver Saathi ?
                    </p>
                    <base-input
                      v-model="whyDoYouWantToPartnerWithCaregiverSaathi"
                      placeholder="Type..."
                      class="md:border-0 lg:border-0 custipshadow"
                      name="Location"
                    ></base-input>
                  </div>
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>

          <!-- ---------------Work With Us-------------- -->
          <div
            class="mt-4 bg-white p-4 rounded-lg"
            v-if="whatAreYouLookingFor === 'Work at CGS'"
          >
            <h4 class="fsize20 font-semibold text-primary">Work With Us</h4>
            <el-tabs v-model="activeName3" @tab-click="clearForm">
              <!--volunteer  -->
              <el-tab-pane label="Volunteer" name="Volunteer">
                <p class="fsize16 text-gray mt-1">
                  Join Caregiver Saathi as a volunteer and make a tangible
                  impact in the lives of caregivers. Contribute your time,
                  skills, and compassion to support our mission of providing
                  holistic care and assistance to those in need, fostering a
                  community of empathy and understanding.
                  <br />
                  The Caregiver Saathi volunteership will contribute and help
                  you gain experience in multiple facets of social enterprise.
                  Please fill the details below & complete the registration
                  process.
                </p>
                <div
                  class="my-4 grid lg:grid-cols-2 md:grid-cols-2 grid-cols-1 gap-2 items-start"
                >
                  <div class="">
                    <p class="input-title textcolor text-primary">Age</p>
                    <base-input
                      v-model="age"
                      placeholder="Type..."
                      class="md:border-0 lg:border-0 custipshadow"
                      name="Experience"
                    ></base-input>
                  </div>

                  <div class="">
                    <p class="input-title textcolor text-primary">
                      Last Qualification
                    </p>
                    <base-input
                      v-model="lastQualification"
                      placeholder="Type..."
                      class="md:border-0 lg:border-0 custipshadow"
                      name="Location"
                    ></base-input>
                  </div>
                  <div class="">
                    <p class="input-title textcolor text-primary">
                      Current Profession
                    </p>
                    <base-input
                      v-model="currentProfession"
                      placeholder="Type..."
                      class="md:border-0 lg:border-0 custipshadow"
                      name="Location"
                    ></base-input>
                  </div>
                  <div class="">
                    <p class="input-title textcolor text-primary">
                      What languages do you speak?
                    </p>
                    <base-input
                      v-model="whatLanguagesDoYouSpeak"
                      placeholder="Type..."
                      class="md:border-0 lg:border-0 custipshadow"
                      name="Location"
                    ></base-input>
                  </div>
                  <div class="">
                    <p class="input-title textcolor text-primary">
                      How much time can you give?
                    </p>
                    <base-input
                      v-model="howMuchTimeCanYouGive"
                      placeholder="Type..."
                      class="md:border-0 lg:border-0 custipshadow"
                      name="Location"
                    ></base-input>
                  </div>
                  <div class="">
                    <p class="text-primary">
                      Which of these specific areas would you like to work in?
                    </p>
                    <!-- <b-form-select
                    v-model="whichOfTheseSpecificAreasWouldYouLikeToWorkIn"
                    :options="options10"
                  ></b-form-select> -->
                    <Multiselect
                      :options="options10"
                      v-model="whichOfTheseSpecificAreasWouldYouLikeToWorkIn"
                    />
                  </div>
                  <div class="">
                    <p class="input-title textcolor text-primary">
                      Have you been a volunteer elsewhere?
                    </p>
                    <b-form-radio
                      v-model="haveYouBeenAVolunteerElseWhere"
                      :aria-describedby="ariaDescribedby"
                      name="some-radios"
                      value="Yes"
                      >Yes</b-form-radio
                    >
                    <b-form-radio
                      v-model="haveYouBeenAVolunteerElseWhere"
                      :aria-describedby="ariaDescribedby"
                      name="some-radios"
                      value="No"
                      >No</b-form-radio
                    >
                  </div>
                  <div class="">
                    <p class="input-title textcolor text-primary">
                      If Yes, where?
                    </p>
                    <base-input
                      v-model="haveYouBeenAVolunteerElseWhere_Place"
                      placeholder="Type..."
                      class="md:border-0 lg:border-0 custipshadow"
                      name="Location"
                    ></base-input>
                  </div>
                  <div class="">
                    <p class="input-title textcolor text-primary">
                      What skills/knowledge/talents can you share?
                    </p>
                    <base-input
                      v-model="whatSkillsKnowledgesTalentsCanYouShare"
                      placeholder="Type..."
                      class="md:border-0 lg:border-0 custipshadow"
                      name="Location"
                    ></base-input>
                  </div>
                  <div class="">
                    <p class="input-title textcolor text-primary">
                      Why does Caregiver Saathi appeal to you?
                    </p>
                    <base-input
                      v-model="whyDoesCaregiverSaathiAppealToYou"
                      placeholder="Type..."
                      class="md:border-0 lg:border-0 custipshadow"
                      name="Location"
                    ></base-input>
                  </div>
                  <div class="">
                    <p class="input-title textcolor text-primary">
                      Any other information you would like us to know?
                    </p>
                    <base-input
                      v-model="anyOtherInformation"
                      placeholder="Type..."
                      class="md:border-0 lg:border-0 custipshadow"
                      name="Location"
                    ></base-input>
                  </div>
                </div>
                <p class="fsize14 text-gray">
                  This will help us leverage your experience/interests in
                  creative ways that you may find interesting
                </p>
              </el-tab-pane>
              <el-tab-pane label="Interships" name="Interships">
                <p class="fsize16 text-gray mt-1">
                  Embark on a meaningful journey with Caregiver Saathi through
                  our internship program. Gain invaluable experience, learn from
                  seasoned professionals, and contribute to initiatives that
                  make a difference in the lives of caregivers.
                </p>
                <div
                  class="my-4 grid lg:grid-cols-2 md:grid-cols-2 grid-cols-1 gap-2 items-start"
                >
                  <div class="">
                    <p class="input-title textcolor text-primary">
                      College/University Name
                    </p>
                    <base-input
                      v-model="collegeORUniversityName"
                      placeholder="Type..."
                      class="md:border-0 lg:border-0 custipshadow"
                      name="Experience"
                    ></base-input>
                  </div>
                  <div class="">
                    <p class="input-title textcolor text-primary">
                      Expected graduation year
                    </p>
                    <!-- <base-input
                      v-model="expectedGraduationYear"
                      placeholder="Type..."
                      class="md:border-0 lg:border-0 custipshadow"
                      name="Location"
                    ></base-input> -->
                    <el-date-picker
                      v-model="expectedGraduationYear"
                      type="year"
                      placeholder="Pick a year"
                      :picker-options="pickerOptions"
                      :format="dateFormatForGraduationYear"
                      :value-format="dateFormatForGraduationYear"
                    >
                    </el-date-picker>
                  </div>
                  <div class="">
                    <p class="input-title textcolor text-primary">
                      Major/Field of study
                    </p>
                    <base-input
                      v-model="majorFieldOfStudy"
                      placeholder="Type..."
                      class="md:border-0 lg:border-0 custipshadow"
                      name="Location"
                    ></base-input>
                  </div>
                  <div class="">
                    <p class="input-title textcolor text-primary">
                      Preferred start date for internship
                    </p>
                    <!-- <base-input
                      v-model="preferredStartDateOfIntership"
                      type="date"
                      placeholder="Type..."
                      class="md:border-0 lg:border-0 custipshadow"
                      name="Location"
                    ></base-input> -->
                    <el-date-picker
                      class="md:border-0 lg:border-0 custipshadow"
                      v-model="preferredStartDateOfIntership"
                      type="date"
                      placeholder="Select Date"
                      :picker-options="pickerOptions"
                      :format="dateFormat"
                      :value-format="dateFormat"
                    >
                    </el-date-picker>
                  </div>
                  <div class="">
                    <p class="input-title textcolor text-primary">
                      Duration of Internship (e.g., number of weeks or months)
                    </p>
                    <base-input
                      v-model="durationOfInternship"
                      placeholder="Type..."
                      class="md:border-0 lg:border-0 custipshadow"
                      name="Location"
                    ></base-input>
                  </div>
                  <div class="">
                    <p class="input-title textcolor text-primary">
                      Which project are you interested in? The details of all
                      the projects have been shared with your college
                    </p>
                    <!-- <b-form-select
                    v-model="whichProjectAreYouInterestedIn"
                    :options="options9"
                  ></b-form-select> -->
                    <Multiselect
                      :options="options9"
                      v-model="whichProjectAreYouInterestedIn"
                    />
                  </div>
                  <div class="">
                    <p class="input-title textcolor text-primary">
                      Please list any relevant skills or qualifications that
                      make you a strong candidate for this internship
                    </p>
                    <base-input
                      v-model="
                        pleaseListRelevantSkillsThatMakeYouAStrongCandidate_Internship
                      "
                      placeholder="Type..."
                      class="md:border-0 lg:border-0 custipshadow"
                      name="Location"
                    ></base-input>
                  </div>
                  <div class="">
                    <p class="input-title textcolor text-primary">
                      What are your career aspirations and how do you think this
                      role will enable you to reach your career goal?
                    </p>
                    <base-input
                      v-model="whatAreYourCareerAspirations_Internship"
                      placeholder="Type..."
                      class="md:border-0 lg:border-0 custipshadow"
                      name="Location"
                    ></base-input>
                  </div>
                  <div class="">
                    <p class="input-title textcolor text-primary">
                      What are the traits that you are proud of and what traits
                      are you looking to build?
                    </p>
                    <base-input
                      v-model="
                        whatAreTheTraitsThatYouAreProudoffAndWhatTraitsAreYouLookingToBuild_Internship
                      "
                      placeholder="Type..."
                      class="md:border-0 lg:border-0 custipshadow"
                      name="Location"
                    ></base-input>
                  </div>
                  <div class="">
                    <p class="input-title textcolor text-primary">
                      Link to Resume/CV - it should be uploaded on a drive and
                      send the link
                    </p>
                    <base-input
                      v-model="linkToResume_Internship"
                      placeholder="Type..."
                      class="md:border-0 lg:border-0 custipshadow"
                      name="Location"
                    ></base-input>
                  </div>
                  <div class="">
                    <p class="input-title textcolor text-primary">
                      Link to Video: A video that you have recorded about
                      yourself, your accomplishments, and your understanding of
                      Caregiver Saathi and association with the purpose of the
                      organization.
                    </p>
                    <base-input
                      v-model="linkToVideo_Internship"
                      placeholder="Type..."
                      class="md:border-0 lg:border-0 custipshadow"
                      name="Location"
                    ></base-input>
                  </div>
                </div>
              </el-tab-pane>
              <el-tab-pane label="Fellowships" name="Fellowships">
                <p class="fsize16 text-gray mt-1">
                  Join Caregiver Saathi's fellowship program and work closely
                  with our CEO and senior team. Gain hands-on experience,
                  mentorship, and insights into the dynamic world of caregiving
                  support.
                </p>
                <div
                  class="my-4 grid lg:grid-cols-2 md:grid-cols-2 grid-cols-1 gap-2 items-start"
                >
                  <div class="">
                    <p class="input-title textcolor text-primary">
                      Work Experience
                    </p>
                    <base-input
                      v-model="workExprience_Fellowship"
                      placeholder="Type..."
                      class="md:border-0 lg:border-0 custipshadow"
                      name="Experience"
                    ></base-input>
                  </div>
                  <div class="">
                    <p class="input-title textcolor text-primary">
                      Last drawn salary
                    </p>
                    <base-input
                      v-model="lastDrawnSalary_Fellowship"
                      placeholder="Type..."
                      class="md:border-0 lg:border-0 custipshadow"
                      name="Location"
                    ></base-input>
                  </div>
                  <div class="">
                    <p class="input-title textcolor text-primary">
                      Qualification
                    </p>
                    <base-input
                      v-model="qualification_Fellowship"
                      placeholder="Type..."
                      class="md:border-0 lg:border-0 custipshadow"
                      name="Location"
                    ></base-input>
                  </div>
                  <div class="">
                    <p class="input-title textcolor text-primary">
                      Preferred start date
                    </p>
                    <!-- <base-input
                      v-model="preferredStartDate_Fellowship"
                      type="date"
                      placeholder="Type..."
                      class="md:border-0 lg:border-0 custipshadow"
                      name="Location"
                    ></base-input> -->
                    <el-date-picker
                      class="md:border-0 lg:border-0 custipshadow"
                      v-model="preferredStartDate_Fellowship"
                      type="date"
                      placeholder="Select Date"
                      :picker-options="pickerOptions"
                      :format="dateFormat"
                      :value-format="dateFormat"
                    >
                    </el-date-picker>
                  </div>
                  <div class="">
                    <p class="input-title textcolor text-primary">
                      What are the traits that you are proud of and what traits
                      are you looking to build?
                    </p>
                    <base-input
                      v-model="
                        whatAreTheTraitsThatYouAreProudoffAndWhatTraitsAreYouLookingToBuild_Fellowship
                      "
                      placeholder="Type..."
                      class="md:border-0 lg:border-0 custipshadow"
                      name="Location"
                    ></base-input>
                  </div>
                  <div class="">
                    <p class="input-title textcolor text-primary">
                      What are your career aspirations and how do you think this
                      role will enable you to reach your career goal?
                    </p>
                    <base-input
                      v-model="whatAreYourCareerAspirations_Fellowship"
                      placeholder="Type..."
                      class="md:border-0 lg:border-0 custipshadow"
                      name="Location"
                    ></base-input>
                  </div>
                  <div class="">
                    <p class="input-title textcolor text-primary">
                      Please list any relevant skills or qualifications that
                      make you a strong candidate for this role
                    </p>
                    <base-input
                      v-model="
                        pleaseListRelevantSkillsThatMakeYouAStrongCandidate_Fellowship
                      "
                      placeholder="Type..."
                      class="md:border-0 lg:border-0 custipshadow"
                      name="Location"
                    ></base-input>
                  </div>
                  <div class="">
                    <p class="input-title textcolor text-primary">
                      Link to Resume/CV - it should be uploaded on a drive and
                      send the link
                    </p>
                    <base-input
                      v-model="linkToResume_Fellowship"
                      placeholder="Type..."
                      class="md:border-0 lg:border-0 custipshadow"
                      name="Location"
                    ></base-input>
                  </div>
                  <div class="">
                    <p class="input-title textcolor text-primary">
                      Link to Video: A video that you have recorded about
                      yourself, your accomplishments, and your understanding of
                      Caregiver Saathi and association with the purpose of the
                      organization
                    </p>
                    <base-input
                      v-model="linkToVideo_Fellowship"
                      placeholder="Type..."
                      class="md:border-0 lg:border-0 custipshadow"
                      name="Location"
                    ></base-input>
                  </div>
                  <div class="">
                    <p class="input-title textcolor text-primary">
                      References from previous job - Name
                    </p>
                    <base-input
                      v-model="referencesFromPreviousJobName_Fellowship"
                      placeholder="Type..."
                      class="md:border-0 lg:border-0 custipshadow"
                      name="Location"
                    ></base-input>
                  </div>
                  <div class="">
                    <p class="input-title textcolor text-primary">
                      References from previous job - Contact Number
                    </p>
                    <base-input
                      v-model="referencesFromPreviousJobPhone_Fellowship"
                      placeholder="Type..."
                      class="md:border-0 lg:border-0 custipshadow"
                      name="Location"
                    ></base-input>
                  </div>
                  <div class="">
                    <p class="input-title textcolor text-primary">
                      References from previous job -Email
                    </p>
                    <base-input
                      v-model="referencesFromPreviousJobEmail_Fellowship"
                      placeholder="Type..."
                      class="md:border-0 lg:border-0 custipshadow"
                      name="Location"
                    ></base-input>
                  </div>
                </div>
              </el-tab-pane>
              <el-tab-pane label="Jobs" name="Jobs">
                <p class="fsize16 text-gray mt-1">
                  Explore rewarding career opportunities at Caregiver Saathi.
                  Join our passionate team dedicated to supporting caregivers
                  and making a meaningful impact in people's lives
                </p>
                <div
                  class="my-4 grid lg:grid-cols-2 md:grid-cols-2 grid-cols-1 gap-2 items-start"
                >
                  <div class="">
                    <p class="input-title textcolor text-primary">
                      Position Applied For
                    </p>
                    <!-- <b-form-select
                    v-model="positionAppliedFor"
                    :options="options8"
                  ></b-form-select> -->
                    <Multiselect
                      :options="options8"
                      v-model="positionAppliedFor"
                    />
                  </div>
                  <div class="">
                    <p class="input-title textcolor text-primary">
                      Work Experience
                    </p>
                    <base-input
                      v-model="workExprience_Jobs"
                      placeholder="Type..."
                      class="md:border-0 lg:border-0 custipshadow"
                      name="Experience"
                    ></base-input>
                  </div>
                  <div class="">
                    <p class="input-title textcolor text-primary">
                      Last drawn salary
                    </p>
                    <base-input
                      v-model="lastDrawnSalary_Jobs"
                      placeholder="Type..."
                      class="md:border-0 lg:border-0 custipshadow"
                      name="Location"
                    ></base-input>
                  </div>
                  <div class="">
                    <p class="input-title textcolor text-primary">
                      Qualification
                    </p>
                    <base-input
                      v-model="qualification_Jobs"
                      placeholder="Type..."
                      class="md:border-0 lg:border-0 custipshadow"
                      name="Location"
                    ></base-input>
                  </div>
                  <div class="">
                    <p class="input-title textcolor text-primary">
                      Preferred start date
                    </p>
                    <!-- <base-input
                      v-model="preferredStartDate_Jobs"
                      type="date"
                      placeholder="Type..."
                      class="md:border-0 lg:border-0 custipshadow"
                      name="Location"
                      :min="currentDate"
                    ></base-input> -->
                    <el-date-picker
                      class="md:border-0 lg:border-0 custipshadow"
                      v-model="preferredStartDate_Jobs"
                      type="date"
                      placeholder="Select Date"
                      :picker-options="pickerOptions"
                      :format="dateFormat"
                      :value-format="dateFormat"
                    >
                    </el-date-picker>
                  </div>
                  <div class="">
                    <p class="input-title textcolor text-primary">
                      What are the traits that you are proud of and what traits
                      are you looking to build?
                    </p>
                    <base-input
                      v-model="
                        whatAreTheTraitsThatYouAreProudoffAndWhatTraitsAreYouLookingToBuild_Jobs
                      "
                      placeholder="Type..."
                      class="md:border-0 lg:border-0 custipshadow"
                      name="Location"
                    ></base-input>
                  </div>
                  <div class="">
                    <p class="input-title textcolor text-primary">
                      What are your career aspirations and how do you think this
                      role will enable you to reach your career goal?
                    </p>
                    <base-input
                      v-model="whatAreYourCareerAspirations_Jobs"
                      placeholder="Type..."
                      class="md:border-0 lg:border-0 custipshadow"
                      name="Location"
                    ></base-input>
                  </div>
                  <div class="">
                    <p class="input-title textcolor text-primary">
                      Please list any relevant skills or qualifications that
                      make you a strong candidate for this role
                    </p>
                    <base-input
                      v-model="
                        pleaseListRelevantSkillsThatMakeYouAStrongCandidate_Jobs
                      "
                      placeholder="Type..."
                      class="md:border-0 lg:border-0 custipshadow"
                      name="Location"
                    ></base-input>
                  </div>
                  <div class="">
                    <p class="input-title textcolor text-primary">
                      Link to Resume/CV - it should be uploaded on a drive and
                      send the link
                    </p>
                    <base-input
                      v-model="linkToResume_Jobs"
                      placeholder="Type..."
                      class="md:border-0 lg:border-0 custipshadow"
                      name="Location"
                    ></base-input>
                  </div>
                  <div class="">
                    <p class="input-title textcolor text-primary">
                      Link to Video: A video that you have recorded about
                      yourself, your accomplishments, and your understanding of
                      Caregiver Saathi and association with the purpose of the
                      organization
                    </p>
                    <base-input
                      v-model="linkToVideo_Jobs"
                      placeholder="Type..."
                      class="md:border-0 lg:border-0 custipshadow"
                      name="Location"
                    ></base-input>
                  </div>
                  <div class="">
                    <p class="input-title textcolor text-primary">
                      References from previous job - Name
                    </p>
                    <base-input
                      v-model="referencesFromPreviousJobName_Jobs"
                      placeholder="Type..."
                      class="md:border-0 lg:border-0 custipshadow"
                      name="Location"
                    ></base-input>
                  </div>
                  <div class="">
                    <p class="input-title textcolor text-primary">
                      References from previous job - Contact number
                    </p>
                    <base-input
                      v-model="referencesFromPreviousJobPhone_Jobs"
                      placeholder="Type..."
                      class="md:border-0 lg:border-0 custipshadow"
                      name="Location"
                    ></base-input>
                  </div>
                  <div class="">
                    <p class="input-title textcolor text-primary">
                      References from previous job - Email
                    </p>
                    <base-input
                      v-model="referencesFromPreviousJobEmail_Jobs"
                      placeholder="Type..."
                      class="md:border-0 lg:border-0 custipshadow"
                      name="Location"
                    ></base-input>
                  </div>
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>

          <!-- ---------------Share your story-------------- -->
          <div
            class="mt-4 bg-white p-4 rounded-lg"
            v-if="
              whatAreYouLookingFor === 'Share Your Story/ Expertise with us'
            "
          >
            <h4 class="fsize20 font-semibold text-primary">
              Share your Story/ Expertise with us
            </h4>
            <el-tabs v-model="activeName" @tab-click="clearForm" class="mt-4">
              <el-tab-pane label="Gentle Warriors" name="Gentle_Warriors">
                <div class="">
                  <p class="fsize16 text-gray mt-1">
                    Conversation with Gentle Warriors- Gentle Warriors, a
                    podcast by Caregiver Saathi, where experienced caregivers
                    share their stories, insights, and wisdom, providing support
                    and inspiration to those on their own caregiving journey. To
                    know more
                    <a
                      href="https://caregiversaathi.co.in/insights/podcast"
                      class="text-primary underline"
                      >https://caregiversaathi.co.in/insights/podcast</a
                    >
                  </p>
                  <div
                    class="my-4 grid lg:grid-cols-2 md:grid-cols-2 grid-cols-1 gap-2 items-start"
                  >
                    <div class="">
                      <p class="text-primary">
                        How long have you been in caregiving?
                      </p>
                      <base-input
                        v-model="howLongHaveYoubeenInCaregiving_GW"
                        placeholder="Type..."
                        class="md:border-0 lg:border-0 custipshadow"
                        name="Location"
                      ></base-input>
                    </div>
                    <div class="">
                      <p class="input-title textcolor text-primary">
                        Relationship with the person you are caring for
                      </p>
                      <base-input
                        v-model="relationshipWithThePersonYouAreCaringFor_GW"
                        placeholder="Type..."
                        class="md:border-0 lg:border-0 custipshadow"
                        name="Location"
                      ></base-input>
                    </div>
                    <div class="">
                      <p class="input-title textcolor text-primary">
                        Short Description about yourself.
                      </p>
                      <base-input
                        v-model="shortDescriptionOfYourself_GW"
                        placeholder="Type..."
                        class="md:border-0 lg:border-0 custipshadow"
                        name="Location"
                      ></base-input>
                    </div>
                  </div>
                </div>
              </el-tab-pane>
              <el-tab-pane label="Caregiver Diaries" name="Caregiver_Diaries">
                <div class="">
                  <p class="fsize16 text-gray mt-1">
                    Caregiver Diaries, a podcast by Caregiver Saathi, where
                    individuals share their caregiving experiences anonymously,
                    providing a safe space to explore the challenges and
                    triumphs of caregiving without fear of stigma or judgment.
                    To know more

                    <a
                      href="https://caregiversaathi.co.in/insights/podcast"
                      class="text-primary underline"
                      >https://caregiversaathi.co.in/insights/podcast</a
                    >
                  </p>
                  <div
                    class="my-4 grid lg:grid-cols-2 md:grid-cols-2 grid-cols-1 gap-2 items-start"
                  >
                    <div class="">
                      <p class="text-primary">
                        How long have you been in caregiving?
                      </p>
                      <base-input
                        v-model="howLongHaveYoubeenInCaregiving_CD"
                        placeholder="Type..."
                        class="md:border-0 lg:border-0 custipshadow"
                        name="Location"
                      ></base-input>
                    </div>
                    <div class="">
                      <p class="input-title textcolor text-primary">
                        Relationship with the person you are caring for
                      </p>
                      <base-input
                        v-model="relationshipWithThePersonYouAreCaringFor_CD"
                        placeholder="Type..."
                        class="md:border-0 lg:border-0 custipshadow"
                        name="Location"
                      ></base-input>
                    </div>
                    <div class="">
                      <p class="input-title textcolor text-primary">
                        Short Description about yourself.
                      </p>
                      <base-input
                        v-model="shortDescriptionOfYourself_CD"
                        placeholder="Type..."
                        class="md:border-0 lg:border-0 custipshadow"
                        name="Location"
                      ></base-input>
                    </div>
                  </div>
                </div>
              </el-tab-pane>
              <el-tab-pane
                label="Compassionate Caring/ Humanising the Healers"
                name="Compassionate_Caring"
              >
                <div class="">
                  <p class="fsize16 text-gray mt-1">
                    Compassionate Caring, a podcast series by Caregiver Saathi,
                    featuring insightful conversations with experts across seven
                    key areas of holistic living. Discover practical tips and
                    valuable insights to support caregivers on their journey
                    towards well-being and resilience. To know more
                    <a
                      href="https://www.youtube.com/watch?v=sQGg9vRZseQ&list=PL-HFW-ESXPYeFvqAa7aniUa3h4Ax7mjCk"
                      class="text-primary underline"
                      >https://www.youtube.com/watch?v=sQGg9vRZseQ&list=PL-HFW-ESXPYeFvqAa7aniUa3h4Ax7mjCk</a
                    >
                  </p>
                  <div
                    class="my-4 grid lg:grid-cols-2 md:grid-cols-2 grid-cols-1 gap-2 items-start"
                  >
                    <div class="">
                      <p class="text-primary">Which area do you represent</p>
                      <!-- <b-form-select
                      v-model="whichAreaDoYouRepresent"
                      :options="options5"
                    ></b-form-select> -->
                      <Multiselect
                        :options="options5"
                        v-model="whichAreaDoYouRepresent"
                      />
                    </div>
                    <div class="">
                      <p class="input-title textcolor text-primary">
                        Have you had a caregiving experience
                      </p>
                      <base-input
                        v-model="haveYouHadACaregivingExp"
                        placeholder="Type..."
                        class="md:border-0 lg:border-0 custipshadow"
                        name="Location"
                      ></base-input>
                    </div>
                    <div class="">
                      <p class="input-title textcolor text-primary">
                        Please share your website / profile URL
                      </p>
                      <base-input
                        v-model="pleaseShareYourWebsiteorProfileUrl"
                        placeholder="Type..."
                        class="md:border-0 lg:border-0 custipshadow"
                        name="Location"
                      ></base-input>
                    </div>
                    <div class="">
                      <p class="input-title textcolor text-primary">
                        Short description of yourself
                      </p>
                      <base-input
                        v-model="shortDescriptionOfYourself_CC"
                        placeholder="Type..."
                        class="md:border-0 lg:border-0 custipshadow"
                        name="Location"
                      ></base-input>
                    </div>
                  </div>
                </div>
              </el-tab-pane>
              <el-tab-pane label="Print and Pictures " name="Print_Pictures">
                <div class="">
                  <p class="fsize16 text-gray mt-1">
                    The Print and Pictures initiative by Caregiver Saathi offers
                    insightful reviews of books and movies that portray
                    caregiving journeys, providing a platform for reflection,
                    inspiration, and discussion on the diverse experiences of
                    caregivers. To know more
                    <a
                      href="https://www.youtube.com/watch?v=qsDeJrhYDXw&list=PL-HFW-ESXPYe99c-szB4TCsRpF9fE5h3u"
                      class="text-primary underline"
                      >https://www.youtube.com/watch?v=qsDeJrhYDXw&list=PL-HFW-ESXPYe99c-szB4TCsRpF9fE5h3u</a
                    >
                  </p>
                  <div
                    class="my-4 grid lg:grid-cols-2 md:grid-cols-2 grid-cols-1 gap-2 items-start"
                  >
                    <div class="">
                      <p class="text-primary">Title of the Book/Movie</p>
                      <base-input
                        v-model="titleOfYourBookOrMovie"
                        placeholder="Type..."
                        class="md:border-0 lg:border-0 custipshadow"
                        name="Location"
                      ></base-input>
                    </div>
                    <div class="">
                      <p class="input-title textcolor text-primary">
                        Brief Summary of the Book/Movie
                      </p>
                      <base-input
                        v-model="briefSummaryOfYourBookOrMovie"
                        placeholder="Type..."
                        class="md:border-0 lg:border-0 custipshadow"
                        name="Location"
                      ></base-input>
                    </div>
                    <div class="">
                      <p class="input-title textcolor text-primary">
                        Have you had a caregiving experience yourself ?
                      </p>
                      <base-input
                        v-model="haveYouHadACaregivingExpYourself"
                        placeholder="Type..."
                        class="md:border-0 lg:border-0 custipshadow"
                        name="Location"
                      ></base-input>
                    </div>
                    <div class="">
                      <p class="input-title textcolor text-primary">
                        Short description of yourself
                      </p>
                      <base-input
                        v-model="shortDescriptionOfYourself_PP"
                        placeholder="Type..."
                        class="md:border-0 lg:border-0 custipshadow"
                        name="Location"
                      ></base-input>
                    </div>
                  </div>
                </div>
              </el-tab-pane>
              <el-tab-pane label="Future-Fit Corporates" name="FFC">
                <div class="">
                  <p class="fsize16 text-gray mt-1">
                    The Future-Fit Corporates initiative by Caregiver Saathi
                    features conversations with thought leaders in the corporate
                    world, exploring strategies and insights to foster
                    caregiver-friendly workplaces and adapt to the changing
                    landscape of work, ensuring holistic support for employees'
                    caregiving responsibilities. To know more
                    <a
                      href="https://youtube.com/playlist?list=PL-HFW-ESXPYccdLMxTCrbOVE_z6bFtcJf&si=nkr3qbh8fPzwH94I"
                      class="text-primary underline"
                      >https://youtube.com/playlist?list=PL-HFW-ESXPYccdLMxTCrbOVE_z6bFtcJf&si=nkr3qbh8fPzwH94I</a
                    >
                  </p>
                  <div
                    class="my-4 grid lg:grid-cols-2 md:grid-cols-2 grid-cols-1 gap-2 items-start"
                  >
                    <div class="">
                      <p class="text-primary">
                        Have you been in a caregiving role
                      </p>
                      <base-input
                        v-model="haveYouBeenInCaregivingRole"
                        placeholder="Type..."
                        class="md:border-0 lg:border-0 custipshadow"
                        name="Location"
                      ></base-input>
                    </div>
                    <div class="">
                      <p class="input-title textcolor text-primary">
                        A short description of yourself
                      </p>
                      <base-input
                        v-model="shortDescriptionOfYourself_FFC"
                        placeholder="Type..."
                        class="md:border-0 lg:border-0 custipshadow"
                        name="Location"
                      ></base-input>
                    </div>
                    <div class="">
                      <p class="input-title textcolor text-primary">
                        Please provide email id
                      </p>
                      <base-input
                        v-model="pleaseMailYourProfileToProvideEmailId"
                        placeholder="Type..."
                        class="md:border-0 lg:border-0 custipshadow"
                        name="Location"
                      ></base-input>
                    </div>
                    <div class="">
                      <p class="input-title textcolor text-primary">
                        Please share your linked-in profile
                      </p>
                      <base-input
                        v-model="pleaseShareYourLindedInProfile"
                        placeholder="Type..."
                        class="md:border-0 lg:border-0 custipshadow"
                        name="Location"
                      ></base-input>
                    </div>
                  </div>
                </div>
              </el-tab-pane>
              <el-tab-pane label="Heart of Care" name="HC">
                <div class="">
                  <h4 class="fsize20 font-semibold text-primary">
                    Heart of Care
                  </h4>
                  <p class="fsize16 text-gray mt-1">
                    We're creating a digital gallery of powerful images and
                    poems showcasing the craetivity of careers. These artworks
                    will help build a global community,changing the
                    representation of care and making caring communities more
                    visible.
                  </p>
                  <div class="my-4 gap-2 items-start">
                    <div class="mt-2">
                      <p class="text-primary">Choose one of the following</p>
                      <Multiselect
                        :options="typesOfArtworkOptions"
                        v-model="typesOfArtwork"
                      />
                    </div>
                    <div class="mt-2">
                      <p class="input-title textcolor text-primary">
                        Artwork description
                      </p>
                      <quill-editor
                        v-model="artworkDesp"
                        :options="editorOption"
                        class="quill-h200px my-2 bg-white"
                      />
                    </div>
                    <div class="mt-2">
                      <p class="input-title textcolor text-primary">
                        Link to Photo/Vieo - it should be uploaded on a drive
                        and send the link
                      </p>
                      <base-input
                        v-model="artworkUpload"
                        placeholder="Type..."
                        class="md:border-0 lg:border-0 custipshadow"
                        name="Location"
                      ></base-input>
                      <!-- <p class="input-title textcolor text-primary">
                        Upload Photo/Video
                      </p>
                      <div v-if="typesOfArtwork == 'Video'">
                        <FileUploader
                          v-show="!artworkUpload"
                          :image="artworkUpload"
                          :onSuccess="handleSuccess"
                          class="w-full my-1 m-auto display-none custmodal"
                        />

                        <video
                          v-if="artworkUpload"
                          autoplay
                          controls
                          :src="artworkUpload"
                          class="w-full"
                        />
                        <div
                          class="flex justify-center text-red"
                          v-if="artworkUpload"
                          @click="handleRemove"
                        >
                          Remove Video
                        </div>
                      </div>
                      <div v-else>
                        <FileUploader
                          v-show="!artworkUpload"
                          :image="artworkUpload"
                          :onSuccess="handleSuccess"
                          class="w-full my-1 m-auto display-none custmodal"
                        />

                        <img
                          v-if="artworkUpload"
                          :src="artworkUpload"
                          ref="cover"
                          class="w-full my-1 m-auto display-none custmodal"
                        />
                        <div
                          class="flex justify-center text-red"
                          v-if="artworkUpload"
                          @click="handleRemove"
                        >
                          Remove image
                        </div>
                      </div> -->
                    </div>
                  </div>
                  <b-form-checkbox
                    class="text-white mt-2"
                    id="checkbox-1"
                    v-model="artWorkPermission"
                  >
                    <p>
                      <strong>
                        <u class="text-primary" @click="editModal = true"
                          >I consent to give my permission to Caregiver Saathi
                          for using this content</u
                        ></strong
                      >
                    </p></b-form-checkbox
                  >
                  <!-- <p class="fsize14 text-gray">
                  Disclaimer: I consent to give my permission to Caregiver
                  Saathi for using this content
                </p> -->
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>

          <!-- ---------------Register for Events-------------- -->
          <div
            class="mt-4 bg-white p-4 rounded-lg"
            v-if="whatAreYouLookingFor === 'Register for Events'"
          >
            <h4 class="fsize20 font-semibold text-primary">
              Register for Events
            </h4>
            <p class="fsize16 text-gray mt-1">
              When the user selects "Register for Events," the form can branch
              out to gather more specific information about the event they are
              interested in. The additional fields might include:
            </p>
            <div class="mt-4 grid grid-cols-1 lg:w-1/2 gap-2 items-start">
              <div class="">
                <p class="text-primary">Event Type</p>
                <!-- <b-form-select
                v-model="otherIssues"
                :options="options11"
              ></b-form-select> -->
                <Multiselect :options="options11" v-model="eventType" />
              </div>
              <div class="">
                <p class="text-primary">Upcoming Events</p>
                <!-- <Multiselect
                :options="eventUpcomingOptions"
                v-model="eventUpcoming"
              /> -->
                <!-- <el-select
                v-model="eventUpcoming"
                placeholder="Select"
                class="mt-1 w-full"
              >
                <el-option
                  v-for="item in eventUpcomingOptions"
                  :key="item._id"
                  :label="item.title"
                  :value="item._id"
                >
                </el-option>
              </el-select> -->
                <b-form-select
                  v-model="eventUpcoming"
                  placeholder="Select"
                  class="w-full"
                >
                  <b-form-select-option
                    v-for="item in eventUpcomingOptions"
                    class="py-5"
                    :key="item._id"
                    :label="item.title"
                    :value="item._id"
                  >
                  </b-form-select-option>
                </b-form-select>
              </div>
              <div class="">
                <p class="input-title textcolor text-primary">Event Details</p>
                <b-textarea
                  v-model="eventDetails"
                  placeholder="Type..."
                  class=""
                  name="Location"
                ></b-textarea>
              </div>
            </div>
            <div class="mt-4">
              <div class="">
                <p class="input-title textcolor text-primary">Event Format</p>
                <el-radio v-model="eventFormat" label="Online">Online</el-radio>
                <el-radio v-model="eventFormat" label="Offline"
                  >Offline</el-radio
                >
              </div>
              <div
                class="grid grid-cols-2 gap-2"
                v-if="eventFormat === 'Online'"
              >
                <div class="">
                  <p class="input-title textcolor text-primary">
                    Registration Link
                  </p>
                  <b-textarea
                    v-model="eventRegistrationLink"
                    placeholder="Type..."
                    class=""
                    name="Location"
                  ></b-textarea>
                </div>
              </div>
              <div
                class="grid grid-cols-2 gap-2"
                v-if="eventFormat === 'Offline'"
              >
                <div class="">
                  <p class="input-title textcolor text-primary">Venue</p>
                  <b-textarea
                    v-model="eventVenue"
                    placeholder="Type..."
                    class=""
                    name="Location"
                  ></b-textarea>
                </div>
                <div class="">
                  <p class="input-title textcolor text-primary">Location</p>
                  <b-textarea
                    v-model="eventLocation"
                    placeholder="Type..."
                    class=""
                    name="Location"
                  ></b-textarea>
                </div>
                <div class="">
                  <p class="input-title textcolor text-primary">Date</p>
                  <!-- <base-input
                    v-model="eventDate"
                    placeholder="Type..."
                    class=""
                    type="date"
                    name="Location"
                  ></base-input> -->
                  <el-date-picker
                    class="md:border-0 lg:border-0 custipshadow"
                    v-model="eventDate"
                    type="date"
                    placeholder="Select Date"
                    :picker-options="pickerOptions"
                    :format="dateFormat"
                    :value-format="dateFormat"
                  >
                  </el-date-picker>
                </div>
                <div class="">
                  <p class="input-title textcolor text-primary">
                    Additional Information
                  </p>
                  <b-textarea
                    v-model="eventAddInformation"
                    placeholder="Type..."
                    class=""
                    name="Location"
                  ></b-textarea>
                </div>
              </div>
            </div>
          </div>

          <!-- ---------------Register for programmers-------------- -->
          <div
            class="mt-4 bg-white p-4 rounded-lg"
            v-if="whatAreYouLookingFor === 'Register for Programmes'"
          >
            <h4 class="fsize20 font-semibold text-primary">
              Register for Programmes
            </h4>
            <p class="fsize16 text-gray mt-1">
              When the user selects "Register for Programmes," the form can
              branch out to gather more specific information about the programme
              they are interested in. The additional fields might include:
            </p>
            <div class="mt-4 grid grid-cols-1 lg:w-1/2 gap-2 items-start">
              <div class="">
                <p class="text-primary">Programme Type</p>

                <!-- <b-form-select
                v-model="programmeType"
                :options="options12"
              ></b-form-select> -->
                <Multiselect :options="options12" v-model="programmeType" />
              </div>
              <div class="">
                <p class="input-title textcolor text-primary">
                  Programme Details
                </p>
                <b-textarea
                  v-model="programmeDetails"
                  placeholder="Type..."
                  class=""
                  name="Location"
                ></b-textarea>
              </div>
            </div>
            <div class="mt-4">
              <div class="">
                <p class="input-title textcolor text-primary">
                  Programme Format
                </p>
                <el-radio v-model="programmeFormat" label="Online"
                  >Online</el-radio
                >
                <el-radio v-model="programmeFormat" label="Offline"
                  >Offline</el-radio
                >
              </div>
              <div
                class="grid grid-cols-2 gap-2"
                v-if="programmeFormat === 'Online'"
              >
                <div class="">
                  <p class="input-title textcolor text-primary">
                    Registration Link
                  </p>
                  <b-textarea
                    v-model="programmeRegistrationLink"
                    placeholder="Type..."
                    class=""
                    name="Location"
                  ></b-textarea>
                </div>
              </div>
              <div class="" v-if="programmeFormat === 'Offline'">
                <div class="grid grid-cols-2 gap-2">
                  <div class="">
                    <p class="input-title textcolor text-primary">Venue</p>
                    <b-textarea
                      v-model="programmeVenue"
                      placeholder="Type..."
                      class=""
                      name="Location"
                    ></b-textarea>
                  </div>
                  <div class="">
                    <p class="input-title textcolor text-primary">Location</p>
                    <b-textarea
                      v-model="programmeLocation"
                      placeholder="Type..."
                      class=""
                      name="Location"
                    ></b-textarea>
                  </div>
                  <div class="">
                    <p class="input-title textcolor text-primary">Date</p>
                    <!-- <base-input
                      v-model="programmeDate"
                      placeholder="Select"
                      class=""
                      type="date"
                      name="Location"
                    ></base-input> -->
                    <el-date-picker
                      class="md:border-0 lg:border-0 custipshadow"
                      v-model="programmeDate"
                      type="date"
                      placeholder="Select Date"
                      :picker-options="pickerOptions"
                      :format="dateFormat"
                      :value-format="dateFormat"
                    >
                    </el-date-picker>
                  </div>
                </div>
                <div class="">
                  <p class="input-title textcolor text-primary">
                    Programme Fee
                  </p>
                  <el-radio v-model="programmeFee" label="Paid">Paid</el-radio>
                  <el-radio v-model="programmeFee" label="Free">Free</el-radio>
                </div>
                <div>
                  <div v-if="programmeFee === 'Paid'">
                    <div class="grid grid-cols-2 gap-2">
                      <div class="">
                        <p class="input-title textcolor text-primary">
                          Fee Amount
                        </p>
                        <b-textarea
                          v-model="programmeFeeAmount"
                          placeholder="Type..."
                          class=""
                          name="Location"
                        ></b-textarea>
                      </div>
                      <div class="">
                        <p class="input-title textcolor text-primary">
                          Additional Information
                        </p>
                        <b-textarea
                          v-model="programmeAddInformation"
                          placeholder="Type..."
                          class=""
                          name="Location"
                        ></b-textarea>
                      </div>
                    </div>
                  </div>
                  <div
                    class="grid grid-cols-2 gap-2"
                    v-if="programmeFee === 'Free'"
                  >
                    <div class="">
                      <p class="input-title textcolor text-primary">
                        Additional Information
                      </p>
                      <b-textarea
                        v-model="programmeAddInformation"
                        placeholder="Type..."
                        class=""
                        name="Location"
                      ></b-textarea>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- ---------------Other Issue-------------- -->
          <div
            class="mt-4 bg-white p-4 rounded-lg"
            v-if="whatAreYouLookingFor === 'Other issue'"
          >
            <h4 class="fsize20 font-semibold text-primary">Other Issues</h4>
            <p class="fsize16 text-gray mt-1">
              For inquiries, feedback, reporting errors, or simply to connect
              with us directly, please use this form. We value your input and
              are here to assist you in any way we can. Thank you for reaching
              out to us.
            </p>
            <div
              class="my-4 grid lg:grid-cols-2 md:grid-cols-2 grid-cols-1 gap-2 items-start"
            >
              <div class="">
                <p class="text-primary">Choose one of the following</p>
                <!-- <b-form-select
                v-model="otherIssues"
                :options="options4"
              ></b-form-select> -->
                <Multiselect :options="options4" v-model="otherIssues" />
              </div>
              <div class="">
                <p class="input-title textcolor text-primary">
                  Please elaborate in detail on the issue/ problem faced
                </p>
                <base-input
                  v-model="pleaseElaborateInDetailOnIssue"
                  placeholder="Type..."
                  class="md:border-0 lg:border-0 custipshadow"
                  name="Location"
                ></base-input>
              </div>
            </div>
          </div>

          <!-- ---------------Submit-------------- -->

          <div
            class="pt-4 w-full"
            v-if="
              whatAreYouLookingFor == 'Share Your Story/ Expertise with us' &&
              activeName == 'HC'
            "
          >
            <b-button
              variant="primary"
              class="px-5"
              @click="addFunc"
              :disabled="artWorkPermission == false"
            >
              Submit
            </b-button>
          </div>
          <div class="pt-4 w-full" v-else>
            <b-button
              variant="primary"
              class="px-5"
              @click="addFunc"
              :disabled="whatAreYouLookingFor == ''"
            >
              Submit
            </b-button>
          </div>
        </ValidationObserver>
      </div>
    </div>
  </div>
</template>

<script>
import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import FileUploader from "@/components/FileUploader";
import { mapState } from "vuex";
import Multiselect from "vue-multiselect";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { extend } from "vee-validate";
import * as rules from "vee-validate/dist/rules";
extend("required", {
  ...rules.required,
  message: "This field is required",
});
extend("integer", {
  ...rules.integer,
  message: "This field must be an integer",
});
extend("alphabetOnly", {
  validate: (value) => /^[a-zA-Z\s]+$/.test(value),
  ...rules.alphabetOnly,
  message: "Name can only contain alphabets and spaces.",
});

export default {
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        },
      },
      // mandatory fields1
      fullName: "",
      emailAddress: "",
      phone: "",
      location: "",
      whatAreYouLookingFor: "",
      options: [
        { value: "Request for Service", text: "Request for Service" },
        {
          value: "Corporate Service/ Partnership",
          text: "Corporate Service/ Partnership",
        },
        { value: "Partner with Us", text: "Partner with Us" },
        { value: "Work at CGS", text: "Work at CGS" },
        {
          value: "Share Your Story/ Expertise with us",
          text: "Share Your Story/ Expertise with us",
        },

        { value: "Register for Events", text: "Register for Events" },
        { value: "Register for Programmes", text: "Register for Programmes" },
        { value: "Other issue", text: "Other issue" },
      ],

      // request for service
      requestForService: [],
      requestForServiceOptions: [
        "Want a care attendant",
        "Caregiver coaching",
        "Grief and Bereavement Counselling",
        "Yoga Therapy",
        "Caregiver Counselling and Therapy",
        "Financial Counseling",
        "Legal Aid - Will writing, living will",
        "Caregiver Coaching",
        "Family Counselling",
        "E Pharmacy",
        "Palliative Care Consultancy",
        "Financial Planning",
        "Inheritance Matters",
        "Geriatric Consultant",
        "Assisted Living Facilities for Elderly",
        "Child Care at home",
        "Self Help Tools",
        "E-Learning/Programs",
        "Join a support group",
        "Pick A subscription plan",
        "Other",
      ],

      // corporate service/partnerships
      organisationName: "",
      officialEmail: "",
      designation: "",
      pleaseTellUsInBriefAboutOrg: "",
      websiteUrl: "",
      inWhatCapacityDoYouWishToPartnerWithUs: "",
      options2: [
        "Become a CSR/ ESG partner",
        "Volunteer programme for employees",
        "Employee Well-being/ Burnout Audit (ISBA)",
        "Employee Engagement-Experience centre",
        "Leadership Workshop",
        "Managing grief at the workplace",
        "Advisory for Caregiver-friendly workplace",
        "Customised project",
      ],
      whatAreYourTop3Obj: "",

      //partner with us- Care Services
      companyName_CARE: "",
      companyAddress_CARE: "",
      companyWebsiteUrl_CARE: "",
      socialMediaUrl_CARE: "",
      yearsInBusiness_CARE: "",
      typesOfServices_CARE: [],
      options3: [
        "Caregiver coaching",
        "Grief & bereavement counselling",
        "Yoga Therapy",
        "Caregiver Counselling and Therapy",
        "Financial Counselling",
        "Geriatric Consultant",
        "Palliative Care Consultant",
        "Childcare Services",
        "Legal Aid - Will writing, living will, Will an inheritance",
        "Professional Care services / Care Attendant providers",
        "Family Counselling",
        "CAssisted living facility for elderly",
        "Any other",
      ],
      additionalQuestions_CARE: "",

      //partner with us- Products
      companyName_PROD: "",
      companyAddress_PROD: "",
      companyWebsiteUrl_PROD: "",
      socialMediaUrl_PROD: "",
      yearsInBusiness_PROD: "",
      typesOfProducts_PROD: [],
      options6: [
        "Mobility aids (wheelchairs, walkers, canes)",
        "Home safety equipment (grab bars, bed rails, shower chairs)",
        "Daily living aids (adaptive utensils, dressing aids, reachers)",
        "Incontinence products (adult diapers, pads, waterproof bedding)",
        "Nutritional supplements and meal replacement shakes",
        "Medication organisers and pill dispensers",
        "Comfort items (weighted blankets, heating pads, aromatherapy)",
        "Memory aids (calendar clocks, memory books, reminder devices)",
        "Adaptive clothing and footwear",
        "Any other",
      ],
      additionalQuestions_PROD: "",

      //partner with us- Collaboration
      companyName_COLLAB: "",
      companyAddress_COLLAB: "",
      companyWebsiteUrl_COLLAB: "",
      socialMediaUrl_COLLAB: "",
      yearsInBusiness_COLLAB: "",
      typesOfCollaboration_COLLAB: [],
      options7: [
        "Joint seminars / Workshops",
        "Content sharing",
        "Joint advocacy and campaigns",
        "Community participation",
        "any other",
      ],
      additionalQuestions_COLLAB: "",

      // partner with us-Care Attendent
      numofYearsInProfessions: "",
      currentCity: "",
      whyDoYouWantToPartnerWithCaregiverSaathi: "",

      // work with us-volunteer
      age: "",
      lastQualification: "",
      currentProfession: "",
      whatLanguagesDoYouSpeak: "",
      howMuchTimeCanYouGive: "",
      whichOfTheseSpecificAreasWouldYouLikeToWorkIn: "",
      options10: [
        "Research",
        "Social Media",
        "Graphic Designing",
        "Content Writing",
        "Video Making",
        "Website Development",
        "Digital Media",
        "Preparing Presentations",
        "Procure Caregiver videos and stories",
        "Data Collection",
        "Helping Caregivers at Hospitals",
        "Conducting Survey with Healthcare Professionals",
        "Home Visits",
        "Community Awareness",
      ],
      haveYouBeenAVolunteerElseWhere: "",
      haveYouBeenAVolunteerElseWhere_Place: "",
      whatSkillsKnowledgesTalentsCanYouShare: "",
      whyDoesCaregiverSaathiAppealToYou: "",
      anyOtherInformation: "",

      // work with us-internships
      collegeORUniversityName: "",
      expectedGraduationYear: "",
      majorFieldOfStudy: "",
      preferredStartDateOfIntership: "",
      durationOfInternship: "",
      whichProjectAreYouInterestedIn: "",
      options9: [
        "Collection of Stories - Gentle Warriors Caregiver Interview & Diaries Initiative",
        "Fundraising Internship for Caregiver Saathi Initiatives",
        "Curating Caregiver Resources from Online Marketplaces",
        "Content Creation and Social Media",
        "Youth Involvement",
        "Community Engagement & Outreach",
      ],
      pleaseListRelevantSkillsThatMakeYouAStrongCandidate_Internship: "",
      whatAreTheTraitsThatYouAreProudoffAndWhatTraitsAreYouLookingToBuild_Internship:
        "",
      whatAreYourCareerAspirations_Internship: "",
      linkToResume_Internship: "",
      linkToVideo_Internship: "",

      // work with us-fellowships
      workExprience_Fellowship: "",
      lastDrawnSalary_Fellowship: "",
      qualification_Fellowship: "",
      preferredStartDate_Fellowship: "",
      whatAreTheTraitsThatYouAreProudoffAndWhatTraitsAreYouLookingToBuild_Fellowship:
        "",
      whatAreYourCareerAspirations_Fellowship: "",
      pleaseListRelevantSkillsThatMakeYouAStrongCandidate_Fellowship: "",
      linkToResume_Fellowship: "",
      linkToVideo_Fellowship: "",
      referencesFromPreviousJobName_Fellowship: "",
      referencesFromPreviousJobPhone_Fellowship: "",
      referencesFromPreviousJobEmail_Fellowship: "",

      // jobs
      positionAppliedFor: "",
      options8: [
        "Program Coordinator - Fundraising & Outreach",
        "Operations/Office Coordinator",
        "Business Development Coordinator",
        "Product Coordinator",
      ],
      workExprience_Jobs: "",
      lastDrawnSalary_Jobs: "",
      qualification_Jobs: "",
      preferredStartDate_Jobs: "",
      whatAreTheTraitsThatYouAreProudoffAndWhatTraitsAreYouLookingToBuild_Jobs:
        "",
      whatAreYourCareerAspirations_Jobs: "",
      pleaseListRelevantSkillsThatMakeYouAStrongCandidate_Jobs: "",
      linkToResume_Jobs: "",
      linkToVideo_Jobs: "",
      referencesFromPreviousJobName_Jobs: "",
      referencesFromPreviousJobPhone_Jobs: "",
      referencesFromPreviousJobEmail_Jobs: "",

      // Share your Story/Expertise with us-Gentle Warriors (GW)
      howLongHaveYoubeenInCaregiving_GW: "",
      relationshipWithThePersonYouAreCaringFor_GW: "",
      shortDescriptionOfYourself_GW: "",

      // Share your Story/Expertise with us-Caregiver Diaries (CD)
      howLongHaveYoubeenInCaregiving_CD: "",
      relationshipWithThePersonYouAreCaringFor_CD: "",
      shortDescriptionOfYourself_CD: "",

      // Share your Story/Expertise with us-Compassionate Caring (CC)/Humanising the healers
      whichAreaDoYouRepresent: [],
      options5: [
        "Physical Well-being",
        "Mental Well-being",
        "Emotional Well-being",
        "Social Well-being",
        "Spiritual Well-being",
        "Environmental Well-being",
        "Occupational Well-being",
      ],
      haveYouHadACaregivingExp: "",
      pleaseShareYourWebsiteorProfileUrl: "",
      shortDescriptionOfYourself_CC: "",

      // Share your Story/Expertise with us-Print and Pictures (PP)
      titleOfYourBookOrMovie: "",
      briefSummaryOfYourBookOrMovie: "",
      shortDescriptionOfYourself_PP: "",
      haveYouHadACaregivingExpYourself: "",

      // Share your Story/Expertise with us-Future Fit Corporate (FFC)
      haveYouBeenInCaregivingRole: "",
      shortDescriptionOfYourself_FFC: "",
      pleaseMailYourProfileToProvideEmailId: "",
      pleaseShareYourLindedInProfile: "",

      // Share your Story/Expertise with us-Heart of care
      typesOfArtwork: "",
      artworkDesp: "",
      artworkUpload: "",
      artWorkPermission: false,
      artworkUploadCoverImg: "",
      typesOfArtworkOptions: ["Poetry", "Photo", "Video", "Prose"],

      // others issues
      otherIssues: "",
      options4: [
        "Call me back",
        "I want to know more - Email",
        "Problem with a product / service",
        "Explore partnerships",
        "Inaccurate data in care directory",
        "Feedback",
      ],
      pleaseElaborateInDetailOnIssue: "",

      // Register for Events
      eventType: "",
      options11: ["Webinar", "Workshop", "Conference"],
      eventUpcoming: "",
      eventUpcomingOptions: [],
      eventDetails: "",
      eventFormat: "",
      // online
      eventRegistrationLink: "",
      // ofline
      eventVenue: "",
      eventLocation: "",
      eventDate: "",
      eventAddInformation: "",

      // Register for Programmes
      programmeType: "",
      options12: ["Caregiver Coaching", "Well-being Series"],
      programmeDetails: "",
      programmeFormat: "",
      // online
      programmeRegistrationLink: "",
      // ofline
      programmeVenue: "",
      programmeLocation: "",
      programmeDate: "",
      programmeFee: "",
      programmeFeeAmount: "",
      programmeAddInformation: "",

      // 3 Share your story tabs- Gentle_Warriors, Caregiver_Diaries, Compassionate_Caring, Print_Pictures, FFC
      activeName: "Gentle_Warriors",

      // 1 Partner With Us tabs- Care_Services, Products, Collaboration, Care_Attendant
      activeName2: "Care_Services",

      // 2 Work With Us tabs- Volunteer, Interships, Fellowships, Jobs
      activeName3: "Volunteer",

      dateFormat: "yyyy-MM-dd",
      dateFormatForGraduationYear: "yyyy",
    };
  },
  components: {
    quillEditor,
    ValidationObserver,
    ValidationProvider,
    rules,
    extend,
    Multiselect,
    FileUploader,
  },
  computed: {
    ...mapState("auth", { user: "user" }),
  },
  methods: {
    async getGlobalFormData() {
      let payload = {
        pagination: true,
      };
      let data = await this.$store.dispatch(
        "globalForm/getglobalform",
        payload
      );
    },
    addToRequestForService(i) {
      this.requestForService.push(i);
    },
    removeFromRequestForService(i) {
      if (this.requestForService.includes(i)) {
        this.requestForService.splice(this.requestForService.indexOf(i), 1);
      }
    },
    async getUpcomingEvents() {
      // this.$refs["obs1"].reset();
      // this.$refs["obs1"].resetValidation();
      let result = await this.$store.dispatch(
        "cms/GetPagesbyCategoryForEvent",
        {
          id: "61e954501a9b68138421810e",
        }
      );
      let result1 = await this.$store.dispatch("ffc/getCorporateEvents");
      this.eventUpcomingOptions = result.data[0].upcoming.concat(
        result1.data.data
      );
    },
    async addFunc() {
      if (!this.location.trim()) {
        await this.$swal.fire({
          text: "Please Fill Data",
          icon: "waring",
          confirmButtonText: "Okay",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
        return false;
      }
      this.$refs.obs1.validate().then(async (success) => {
        if (success) {
          let payload = {
            fullName: this.fullName,
            emailAddress: this.emailAddress,
            phone: this.phone,
            location: this.location,
          };
          const formData = new FormData();

          // Request for Service
          if (this.whatAreYouLookingFor === "Request for Service") {
            Object.assign(payload, {
              whatAreYouLookingFor: this.whatAreYouLookingFor,
            });

            if (this.requestForService.length) {
              Object.assign(payload, {
                requestForService: this.requestForService,
              });

              let data = await this.$store.dispatch(
                "globalForm/addglobalform",
                payload
              );
              console.log(data, "Insert success");
              if (data) {
                await this.$swal.fire({
                  text: "Form Submitted Successfully",
                  icon: "success",
                  confirmButtonText: "Okay",
                  confirmButtonColor: "#830c81",
                  showCancelButton: false,
                });
                window.scrollTo(0, 0);
                this.fullName = "";
                this.emailAddress = "";
                this.phone = "";
                this.location = "";
                this.whatAreYouLookingFor = "";
                this.clearForm();
                this.getGlobalFormData();
                await this.getUpcomingEvents();
              }
            } else {
              await this.$swal.fire({
                text: "Please Select Data",
                icon: "waring",
                confirmButtonText: "Okay",
                confirmButtonColor: "#830c81",
                showCancelButton: false,
              });
            }
          }

          // Corporate Services/ Partnerships
          if (this.whatAreYouLookingFor === "Corporate Service/ Partnership") {
            Object.assign(payload, {
              whatAreYouLookingFor: this.whatAreYouLookingFor,
            });

            const checkFields = [
              this.organisationName,
              this.officialEmail,
              this.designation,
              this.pleaseTellUsInBriefAboutOrg,
              this.websiteUrl,
              this.inWhatCapacityDoYouWishToPartnerWithUs,
              this.whatAreYourTop3Obj,
            ];

            if (checkFields.every((f) => f.trim() === "")) {
              await this.$swal.fire({
                text: "Please Fill Data",
                icon: "waring",
                confirmButtonText: "Okay",
                confirmButtonColor: "#830c81",
                showCancelButton: false,
              });
            } else {
              if (this.organisationName) {
                Object.assign(payload, {
                  organisationName: this.organisationName,
                });
              }
              if (this.officialEmail) {
                Object.assign(payload, { officialEmail: this.officialEmail });
              }
              if (this.designation) {
                Object.assign(payload, { designation: this.designation });
              }
              if (this.pleaseTellUsInBriefAboutOrg) {
                Object.assign(payload, {
                  pleaseTellUsInBriefAboutOrg: this.pleaseTellUsInBriefAboutOrg,
                });
              }
              if (this.websiteUrl) {
                Object.assign(payload, { websiteUrl: this.websiteUrl });
              }
              if (this.inWhatCapacityDoYouWishToPartnerWithUs) {
                Object.assign(payload, {
                  inWhatCapacityDoYouWishToPartnerWithUs:
                    this.inWhatCapacityDoYouWishToPartnerWithUs,
                });
              }
              if (this.whatAreYourTop3Obj) {
                Object.assign(payload, {
                  whatAreYourTop3Obj: this.whatAreYourTop3Obj,
                });
              }
              let data = await this.$store.dispatch(
                "globalForm/addglobalform",
                payload
              );
              console.log(data, "Insert success");
              if (data) {
                await this.$swal.fire({
                  text: "Form Submitted Successfully",
                  icon: "success",
                  confirmButtonText: "Okay",
                  confirmButtonColor: "#830c81",
                  showCancelButton: false,
                });
                this.fullName = "";
                this.emailAddress = "";
                this.phone = "";
                this.location = "";
                this.whatAreYouLookingFor = "";
                this.clearForm();
                this.getGlobalFormData();
                await this.getUpcomingEvents();
              }
            }
          }

          // Partner With Us
          if (this.whatAreYouLookingFor === "Partner with Us") {
            Object.assign(payload, {
              whatAreYouLookingFor: this.whatAreYouLookingFor,
            });

            if (this.activeName2 === "Care_Services") {
              Object.assign(payload, {
                whatAreYouLookingForTabName: "Care Services",
              });

              const checkFields = [
                this.companyName_CARE,
                this.companyAddress_CARE,
                this.companyWebsiteUrl_CARE,
                this.socialMediaUrl_CARE,
                this.yearsInBusiness_CARE,
                this.additionalQuestions_CARE,
              ];

              if (
                checkFields.every((f) => f.trim() === "") &&
                this.typesOfServices_CARE.length == 0
              ) {
                await this.$swal.fire({
                  text: "Please Fill Data",
                  icon: "waring",
                  confirmButtonText: "Okay",
                  confirmButtonColor: "#830c81",
                  showCancelButton: false,
                });
              } else {
                if (this.companyName_CARE) {
                  Object.assign(payload, {
                    companyName_CARE: this.companyName_CARE,
                  });
                }
                if (this.companyAddress_CARE) {
                  Object.assign(payload, {
                    companyAddress_CARE: this.companyAddress_CARE,
                  });
                }
                if (this.companyWebsiteUrl_CARE) {
                  Object.assign(payload, {
                    companyWebsiteUrl_CARE: this.companyWebsiteUrl_CARE,
                  });
                }
                if (this.socialMediaUrl_CARE) {
                  Object.assign(payload, {
                    socialMediaUrl_CARE: this.socialMediaUrl_CARE,
                  });
                }
                if (this.yearsInBusiness_CARE) {
                  Object.assign(payload, {
                    yearsInBusiness_CARE: this.yearsInBusiness_CARE,
                  });
                }
                if (this.typesOfServices_CARE.length) {
                  Object.assign(payload, {
                    typesOfServices_CARE: this.typesOfServices_CARE,
                  });
                }
                if (this.additionalQuestions_CARE) {
                  Object.assign(payload, {
                    additionalQuestions_CARE: this.additionalQuestions_CARE,
                  });
                }

                let data = await this.$store.dispatch(
                  "globalForm/addglobalform",
                  payload
                );
                console.log(data, "Insert success");
                if (data) {
                  await this.$swal.fire({
                    text: "Form Submitted Successfully",
                    icon: "success",
                    confirmButtonText: "Okay",
                    confirmButtonColor: "#830c81",
                    showCancelButton: false,
                  });
                  this.fullName = "";
                  this.emailAddress = "";
                  this.phone = "";
                  this.location = "";
                  this.whatAreYouLookingFor = "";
                  this.clearForm();
                  this.getGlobalFormData();
                  await this.getUpcomingEvents();
                }
              }
            }
            if (this.activeName2 === "Products") {
              Object.assign(payload, {
                whatAreYouLookingForTabName: "Products",
              });

              const checkFields = [
                this.companyName_PROD,
                this.companyAddress_PROD,
                this.companyWebsiteUrl_PROD,
                this.socialMediaUrl_PROD,
                this.yearsInBusiness_PROD,
                this.additionalQuestions_PROD,
              ];

              if (
                checkFields.every((f) => f.trim() === "") &&
                this.typesOfProducts_PROD.length == 0
              ) {
                await this.$swal.fire({
                  text: "Please Fill Data",
                  icon: "waring",
                  confirmButtonText: "Okay",
                  confirmButtonColor: "#830c81",
                  showCancelButton: false,
                });
              } else {
                if (this.companyName_PROD) {
                  Object.assign(payload, {
                    companyName_PROD: this.companyName_PROD,
                  });
                }
                if (this.companyAddress_PROD) {
                  Object.assign(payload, {
                    companyAddress_PROD: this.companyAddress_PROD,
                  });
                }
                if (this.companyWebsiteUrl_PROD) {
                  Object.assign(payload, {
                    companyWebsiteUrl_PROD: this.companyWebsiteUrl_PROD,
                  });
                }
                if (this.socialMediaUrl_PROD) {
                  Object.assign(payload, {
                    socialMediaUrl_PROD: this.socialMediaUrl_PROD,
                  });
                }
                if (this.yearsInBusiness_PROD) {
                  Object.assign(payload, {
                    yearsInBusiness_PROD: this.yearsInBusiness_PROD,
                  });
                }
                if (this.typesOfProducts_PROD.length) {
                  Object.assign(payload, {
                    typesOfProducts_PROD: this.typesOfProducts_PROD,
                  });
                }
                if (this.additionalQuestions_PROD) {
                  Object.assign(payload, {
                    additionalQuestions_PROD: this.additionalQuestions_PROD,
                  });
                }

                let data = await this.$store.dispatch(
                  "globalForm/addglobalform",
                  payload
                );
                console.log(data, "Insert success");
                if (data) {
                  await this.$swal.fire({
                    text: "Form Submitted Successfully",
                    icon: "success",
                    confirmButtonText: "Okay",
                    confirmButtonColor: "#830c81",
                    showCancelButton: false,
                  });
                  this.fullName = "";
                  this.emailAddress = "";
                  this.phone = "";
                  this.location = "";
                  this.whatAreYouLookingFor = "";
                  this.clearForm();
                  this.getGlobalFormData();
                  await this.getUpcomingEvents();
                }
              }
            }
            if (this.activeName2 === "Collaboration") {
              Object.assign(payload, {
                whatAreYouLookingForTabName: "Collaboration",
              });

              const checkFields = [
                this.companyName_COLLAB,
                this.companyAddress_COLLAB,
                this.companyWebsiteUrl_COLLAB,
                this.socialMediaUrl_COLLAB,
                this.yearsInBusiness_COLLAB,
                this.typesOfCollaboration_COLLAB,
                this.additionalQuestions_COLLAB,
              ];

              if (checkFields.every((f) => f.trim() === "")) {
                await this.$swal.fire({
                  text: "Please Fill Data",
                  icon: "waring",
                  confirmButtonText: "Okay",
                  confirmButtonColor: "#830c81",
                  showCancelButton: false,
                });
              } else {
                if (this.companyName_COLLAB) {
                  Object.assign(payload, {
                    companyName_COLLAB: this.companyName_COLLAB,
                  });
                }
                if (this.companyAddress_COLLAB) {
                  Object.assign(payload, {
                    companyAddress_COLLAB: this.companyAddress_COLLAB,
                  });
                }
                if (this.companyWebsiteUrl_COLLAB) {
                  Object.assign(payload, {
                    companyWebsiteUrl_COLLAB: this.companyWebsiteUrl_COLLAB,
                  });
                }
                if (this.socialMediaUrl_COLLAB) {
                  Object.assign(payload, {
                    socialMediaUrl_COLLAB: this.socialMediaUrl_COLLAB,
                  });
                }
                if (this.yearsInBusiness_COLLAB) {
                  Object.assign(payload, {
                    yearsInBusiness_COLLAB: this.yearsInBusiness_COLLAB,
                  });
                }
                if (this.typesOfCollaboration_COLLAB) {
                  Object.assign(payload, {
                    typesOfCollaboration_COLLAB:
                      this.typesOfCollaboration_COLLAB,
                  });
                }
                if (this.additionalQuestions_COLLAB) {
                  Object.assign(payload, {
                    additionalQuestions_COLLAB: this.additionalQuestions_COLLAB,
                  });
                }

                let data = await this.$store.dispatch(
                  "globalForm/addglobalform",
                  payload
                );
                console.log(data, "Insert success");
                if (data) {
                  await this.$swal.fire({
                    text: "Form Submitted Successfully",
                    icon: "success",
                    confirmButtonText: "Okay",
                    confirmButtonColor: "#830c81",
                    showCancelButton: false,
                  });
                  this.fullName = "";
                  this.emailAddress = "";
                  this.phone = "";
                  this.location = "";
                  this.whatAreYouLookingFor = "";
                  this.clearForm();
                  this.getGlobalFormData();
                  await this.getUpcomingEvents();
                }
              }
            }
            if (this.activeName2 === "Care_Attendant") {
              Object.assign(payload, {
                whatAreYouLookingForTabName: "Care Attendent",
              });
              const checkFields = [
                this.numofYearsInProfessions,
                this.currentCity,
                this.whyDoYouWantToPartnerWithCaregiverSaathi,
              ];

              if (checkFields.every((f) => f.trim() === "")) {
                await this.$swal.fire({
                  text: "Please Fill Data",
                  icon: "waring",
                  confirmButtonText: "Okay",
                  confirmButtonColor: "#830c81",
                  showCancelButton: false,
                });
              } else {
                if (this.numofYearsInProfessions) {
                  Object.assign(payload, {
                    numofYearsInProfessions: this.numofYearsInProfessions,
                  });
                }
                if (this.currentCity) {
                  Object.assign(payload, {
                    currentCity: this.currentCity,
                  });
                }
                if (this.whyDoYouWantToPartnerWithCaregiverSaathi) {
                  Object.assign(payload, {
                    whyDoYouWantToPartnerWithCaregiverSaathi:
                      this.whyDoYouWantToPartnerWithCaregiverSaathi,
                  });
                }
                let data = await this.$store.dispatch(
                  "globalForm/addglobalform",
                  payload
                );
                console.log(data, "Insert success");
                if (data) {
                  await this.$swal.fire({
                    text: "Form Submitted Successfully",
                    icon: "success",
                    confirmButtonText: "Okay",
                    confirmButtonColor: "#830c81",
                    showCancelButton: false,
                  });
                  this.fullName = "";
                  this.emailAddress = "";
                  this.phone = "";
                  this.location = "";
                  this.whatAreYouLookingFor = "";
                  this.clearForm();
                  this.getGlobalFormData();
                  await this.getUpcomingEvents();
                }
              }
            }
          }

          // Work With Us
          if (this.whatAreYouLookingFor === "Work at CGS") {
            Object.assign(payload, {
              whatAreYouLookingFor: this.whatAreYouLookingFor,
            });
            if (this.activeName3 === "Volunteer") {
              Object.assign(payload, {
                whatAreYouLookingForTabName: "Volunteer",
              });

              const checkFields = [
                this.age,
                this.lastQualification,
                this.currentProfession,
                this.whatLanguagesDoYouSpeak,
                this.howMuchTimeCanYouGive,
                this.whichOfTheseSpecificAreasWouldYouLikeToWorkIn,
                this.haveYouBeenAVolunteerElseWhere,
                this.haveYouBeenAVolunteerElseWhere_Place,
                this.whatSkillsKnowledgesTalentsCanYouShare,
                this.whyDoesCaregiverSaathiAppealToYou,
                this.anyOtherInformation,
              ];

              if (checkFields.every((f) => f.trim() === "")) {
                await this.$swal.fire({
                  text: "Please Fill Data",
                  icon: "waring",
                  confirmButtonText: "Okay",
                  confirmButtonColor: "#830c81",
                  showCancelButton: false,
                });
              } else {
                if (this.age) {
                  Object.assign(payload, {
                    age: this.age,
                  });
                }
                if (this.lastQualification) {
                  Object.assign(payload, {
                    lastQualification: this.lastQualification,
                  });
                }
                if (this.currentProfession) {
                  Object.assign(payload, {
                    currentProfession: this.currentProfession,
                  });
                }
                if (this.whatLanguagesDoYouSpeak) {
                  Object.assign(payload, {
                    whatLanguagesDoYouSpeak: this.whatLanguagesDoYouSpeak,
                  });
                }
                if (this.howMuchTimeCanYouGive) {
                  Object.assign(payload, {
                    howMuchTimeCanYouGive: this.howMuchTimeCanYouGive,
                  });
                }
                if (this.whichOfTheseSpecificAreasWouldYouLikeToWorkIn) {
                  Object.assign(payload, {
                    whichOfTheseSpecificAreasWouldYouLikeToWorkIn:
                      this.whichOfTheseSpecificAreasWouldYouLikeToWorkIn,
                  });
                }
                if (this.haveYouBeenAVolunteerElseWhere) {
                  Object.assign(payload, {
                    haveYouBeenAVolunteerElseWhere:
                      this.haveYouBeenAVolunteerElseWhere,
                  });
                }
                if (this.haveYouBeenAVolunteerElseWhere_Place) {
                  Object.assign(payload, {
                    haveYouBeenAVolunteerElseWhere_Place:
                      this.haveYouBeenAVolunteerElseWhere_Place,
                  });
                }
                if (this.whatSkillsKnowledgesTalentsCanYouShare) {
                  Object.assign(payload, {
                    whatSkillsKnowledgesTalentsCanYouShare:
                      this.whatSkillsKnowledgesTalentsCanYouShare,
                  });
                }
                if (this.whyDoesCaregiverSaathiAppealToYou) {
                  Object.assign(payload, {
                    whyDoesCaregiverSaathiAppealToYou:
                      this.whyDoesCaregiverSaathiAppealToYou,
                  });
                }
                if (this.anyOtherInformation) {
                  Object.assign(payload, {
                    anyOtherInformation: this.anyOtherInformation,
                  });
                }

                let data = await this.$store.dispatch(
                  "globalForm/addglobalform",
                  payload
                );
                console.log(data, "Insert success");
                if (data) {
                  await this.$swal.fire({
                    text: "Form Submitted Successfully",
                    icon: "success",
                    confirmButtonText: "Okay",
                    confirmButtonColor: "#830c81",
                    showCancelButton: false,
                  });
                  this.fullName = "";
                  this.emailAddress = "";
                  this.phone = "";
                  this.location = "";
                  this.whatAreYouLookingFor = "";
                  this.clearForm();
                  this.getGlobalFormData();
                  await this.getUpcomingEvents();
                }
              }
            }
            if (this.activeName3 === "Interships") {
              Object.assign(payload, {
                whatAreYouLookingForTabName: "Interships",
              });
              const checkFields = [
                this.collegeORUniversityName,
                this.expectedGraduationYear,
                this.majorFieldOfStudy,
                // this.preferredStartDateOfIntership,
                this.durationOfInternship,
                // this.whichProjectAreYouInterestedIn,
                this
                  .pleaseListRelevantSkillsThatMakeYouAStrongCandidate_Internship,
                this.whatAreYourCareerAspirations_Internship,
                this
                  .whatAreTheTraitsThatYouAreProudoffAndWhatTraitsAreYouLookingToBuild_Internship,
                this.linkToResume_Internship,
                this.linkToVideo_Internship,
              ];

              if (
                checkFields.every((f) => f.trim() === "") &&
                this.whichProjectAreYouInterestedIn.length == 0
              ) {
                await this.$swal.fire({
                  text: "Please Fill Data",
                  icon: "waring",
                  confirmButtonText: "Okay",
                  confirmButtonColor: "#830c81",
                  showCancelButton: false,
                });
              } else {
                if (this.collegeORUniversityName) {
                  Object.assign(payload, {
                    collegeORUniversityName: this.collegeORUniversityName,
                  });
                }
                if (this.expectedGraduationYear) {
                  Object.assign(payload, {
                    expectedGraduationYear: this.expectedGraduationYear,
                  });
                }
                if (this.majorFieldOfStudy) {
                  Object.assign(payload, {
                    majorFieldOfStudy: this.majorFieldOfStudy,
                  });
                }
                if (this.preferredStartDateOfIntership) {
                  Object.assign(payload, {
                    preferredStartDateOfIntership:
                      this.preferredStartDateOfIntership,
                  });
                }
                if (this.durationOfInternship) {
                  Object.assign(payload, {
                    durationOfInternship: this.durationOfInternship,
                  });
                }
                if (this.whichProjectAreYouInterestedIn) {
                  Object.assign(payload, {
                    whichProjectAreYouInterestedIn:
                      this.whichProjectAreYouInterestedIn,
                  });
                }
                if (
                  this
                    .pleaseListRelevantSkillsThatMakeYouAStrongCandidate_Internship
                ) {
                  Object.assign(payload, {
                    pleaseListRelevantSkillsThatMakeYouAStrongCandidate_Internship:
                      this
                        .pleaseListRelevantSkillsThatMakeYouAStrongCandidate_Internship,
                  });
                }
                if (this.whatAreYourCareerAspirations_Internship) {
                  Object.assign(payload, {
                    whatAreYourCareerAspirations_Internship:
                      this.whatAreYourCareerAspirations_Internship,
                  });
                }
                if (
                  this
                    .whatAreTheTraitsThatYouAreProudoffAndWhatTraitsAreYouLookingToBuild_Internship
                ) {
                  Object.assign(payload, {
                    whatAreTheTraitsThatYouAreProudoffAndWhatTraitsAreYouLookingToBuild_Internship:
                      this
                        .whatAreTheTraitsThatYouAreProudoffAndWhatTraitsAreYouLookingToBuild_Internship,
                  });
                }
                if (this.linkToResume_Internship) {
                  Object.assign(payload, {
                    linkToResume_Internship: this.linkToResume_Internship,
                  });
                }
                if (this.linkToVideo_Internship) {
                  Object.assign(payload, {
                    linkToVideo_Internship: this.linkToVideo_Internship,
                  });
                }

                let data = await this.$store.dispatch(
                  "globalForm/addglobalform",
                  payload
                );
                console.log(data, "Insert success");
                if (data) {
                  await this.$swal.fire({
                    text: "Form Submitted Successfully",
                    icon: "success",
                    confirmButtonText: "Okay",
                    confirmButtonColor: "#830c81",
                    showCancelButton: false,
                  });
                  this.fullName = "";
                  this.emailAddress = "";
                  this.phone = "";
                  this.location = "";
                  this.whatAreYouLookingFor = "";
                  this.clearForm();
                  this.getGlobalFormData();
                  await this.getUpcomingEvents();
                }
              }
            }
            if (this.activeName3 === "Fellowships") {
              // Fellowships
              Object.assign(payload, {
                whatAreYouLookingForTabName: "Fellowships",
              });

              const checkFields = [
                this.workExprience_Fellowship,
                this.lastDrawnSalary_Fellowship,
                this.qualification_Fellowship,
                this.preferredStartDate_Fellowship,
                this
                  .whatAreTheTraitsThatYouAreProudoffAndWhatTraitsAreYouLookingToBuild_Fellowship,
                this.whatAreYourCareerAspirations_Fellowship,
                this
                  .pleaseListRelevantSkillsThatMakeYouAStrongCandidate_Fellowship,
                this.linkToResume_Fellowship,
                this.linkToVideo_Fellowship,
                this.referencesFromPreviousJobName_Fellowship,
                this.referencesFromPreviousJobPhone_Fellowship,
                this.referencesFromPreviousJobEmail_Fellowship,
              ];

              if (checkFields.every((f) => f.trim() === "")) {
                await this.$swal.fire({
                  text: "Please Fill Data",
                  icon: "waring",
                  confirmButtonText: "Okay",
                  confirmButtonColor: "#830c81",
                  showCancelButton: false,
                });
              } else {
                if (this.workExprience_Fellowship) {
                  Object.assign(payload, {
                    workExprience_Fellowship: this.workExprience_Fellowship,
                  });
                }
                if (this.lastDrawnSalary_Fellowship) {
                  Object.assign(payload, {
                    lastDrawnSalary_Fellowship: this.lastDrawnSalary_Fellowship,
                  });
                }
                if (this.qualification_Fellowship) {
                  Object.assign(payload, {
                    qualification_Fellowship: this.qualification_Fellowship,
                  });
                }
                if (this.preferredStartDate_Fellowship) {
                  Object.assign(payload, {
                    preferredStartDate_Fellowship:
                      this.preferredStartDate_Fellowship,
                  });
                }
                if (
                  this
                    .whatAreTheTraitsThatYouAreProudoffAndWhatTraitsAreYouLookingToBuild_Fellowship
                ) {
                  Object.assign(payload, {
                    whatAreTheTraitsThatYouAreProudoffAndWhatTraitsAreYouLookingToBuild_Fellowship:
                      this
                        .whatAreTheTraitsThatYouAreProudoffAndWhatTraitsAreYouLookingToBuild_Fellowship,
                  });
                }
                if (this.whatAreYourCareerAspirations_Fellowship) {
                  Object.assign(payload, {
                    whatAreYourCareerAspirations_Fellowship:
                      this.whatAreYourCareerAspirations_Fellowship,
                  });
                }
                if (
                  this
                    .pleaseListRelevantSkillsThatMakeYouAStrongCandidate_Fellowship
                ) {
                  Object.assign(payload, {
                    pleaseListRelevantSkillsThatMakeYouAStrongCandidate_Fellowship:
                      this
                        .pleaseListRelevantSkillsThatMakeYouAStrongCandidate_Fellowship,
                  });
                }
                if (this.linkToResume_Fellowship) {
                  Object.assign(payload, {
                    linkToResume_Fellowship: this.linkToResume_Fellowship,
                  });
                }
                if (this.linkToVideo_Fellowship) {
                  Object.assign(payload, {
                    linkToVideo_Fellowship: this.linkToVideo_Fellowship,
                  });
                }
                if (this.referencesFromPreviousJobName_Fellowship) {
                  Object.assign(payload, {
                    referencesFromPreviousJobName_Fellowship:
                      this.referencesFromPreviousJobName_Fellowship,
                  });
                }
                if (this.referencesFromPreviousJobPhone_Fellowship) {
                  Object.assign(payload, {
                    referencesFromPreviousJobPhone_Fellowship:
                      this.referencesFromPreviousJobPhone_Fellowship,
                  });
                }
                if (this.referencesFromPreviousJobEmail_Fellowship) {
                  Object.assign(payload, {
                    referencesFromPreviousJobEmail_Fellowship:
                      this.referencesFromPreviousJobEmail_Fellowship,
                  });
                }

                let data = await this.$store.dispatch(
                  "globalForm/addglobalform",
                  payload
                );
                console.log(data, "Insert success");
                if (data) {
                  await this.$swal.fire({
                    text: "Form Submitted Successfully",
                    icon: "success",
                    confirmButtonText: "Okay",
                    confirmButtonColor: "#830c81",
                    showCancelButton: false,
                  });
                  this.fullName = "";
                  this.emailAddress = "";
                  this.phone = "";
                  this.location = "";
                  this.whatAreYouLookingFor = "";
                  this.clearForm();
                  this.getGlobalFormData();
                  await this.getUpcomingEvents();
                }
              }
            }
            if (this.activeName3 === "Jobs") {
              Object.assign(payload, {
                whatAreYouLookingForTabName: "Jobs",
              });
              const checkFields = [
                this.positionAppliedFor,
                this.workExprience_Jobs,
                this.lastDrawnSalary_Jobs,
                this.qualification_Jobs,
                this.preferredStartDate_Jobs,
                this
                  .whatAreTheTraitsThatYouAreProudoffAndWhatTraitsAreYouLookingToBuild_Jobs,
                this.whatAreYourCareerAspirations_Jobs,
                this.pleaseListRelevantSkillsThatMakeYouAStrongCandidate_Jobs,
                this.linkToResume_Jobs,
                this.linkToVideo_Jobs,
                this.referencesFromPreviousJobName_Jobs,
                this.referencesFromPreviousJobPhone_Jobs,
                this.referencesFromPreviousJobEmail_Jobs,
              ];

              if (checkFields.every((f) => f.trim() === "")) {
                await this.$swal.fire({
                  text: "Please Fill Data",
                  icon: "waring",
                  confirmButtonText: "Okay",
                  confirmButtonColor: "#830c81",
                  showCancelButton: false,
                });
              } else {
                if (this.positionAppliedFor) {
                  Object.assign(payload, {
                    positionAppliedFor: this.positionAppliedFor,
                  });
                }
                if (this.workExprience_Jobs) {
                  Object.assign(payload, {
                    workExprience_Jobs: this.workExprience_Jobs,
                  });
                }
                if (this.lastDrawnSalary_Jobs) {
                  Object.assign(payload, {
                    lastDrawnSalary_Jobs: this.lastDrawnSalary_Jobs,
                  });
                }
                if (this.qualification_Jobs) {
                  Object.assign(payload, {
                    qualification_Jobs: this.qualification_Jobs,
                  });
                }
                if (this.preferredStartDate_Jobs) {
                  Object.assign(payload, {
                    preferredStartDate_Jobs: this.preferredStartDate_Jobs,
                  });
                }
                if (
                  this
                    .whatAreTheTraitsThatYouAreProudoffAndWhatTraitsAreYouLookingToBuild_Jobs
                ) {
                  Object.assign(payload, {
                    whatAreTheTraitsThatYouAreProudoffAndWhatTraitsAreYouLookingToBuild_Jobs:
                      this
                        .whatAreTheTraitsThatYouAreProudoffAndWhatTraitsAreYouLookingToBuild_Jobs,
                  });
                }
                if (this.whatAreYourCareerAspirations_Jobs) {
                  Object.assign(payload, {
                    whatAreYourCareerAspirations_Jobs:
                      this.whatAreYourCareerAspirations_Jobs,
                  });
                }
                if (
                  this.pleaseListRelevantSkillsThatMakeYouAStrongCandidate_Jobs
                ) {
                  Object.assign(payload, {
                    pleaseListRelevantSkillsThatMakeYouAStrongCandidate_Jobs:
                      this
                        .pleaseListRelevantSkillsThatMakeYouAStrongCandidate_Jobs,
                  });
                }
                if (this.linkToResume_Jobs) {
                  Object.assign(payload, {
                    linkToResume_Jobs: this.linkToResume_Jobs,
                  });
                }
                if (this.linkToVideo_Jobs) {
                  Object.assign(payload, {
                    linkToVideo_Jobs: this.linkToVideo_Jobs,
                  });
                }
                if (this.referencesFromPreviousJobName_Jobs) {
                  Object.assign(payload, {
                    referencesFromPreviousJobName_Jobs:
                      this.referencesFromPreviousJobName_Jobs,
                  });
                }
                if (this.referencesFromPreviousJobPhone_Jobs) {
                  Object.assign(payload, {
                    referencesFromPreviousJobPhone_Jobs:
                      this.referencesFromPreviousJobPhone_Jobs,
                  });
                }
                if (this.referencesFromPreviousJobEmail_Jobs) {
                  Object.assign(payload, {
                    referencesFromPreviousJobEmail_Jobs:
                      this.referencesFromPreviousJobEmail_Jobs,
                  });
                }

                let data = await this.$store.dispatch(
                  "globalForm/addglobalform",
                  payload
                );
                console.log(data, "Insert success");
                if (data) {
                  await this.$swal.fire({
                    text: "Form Submitted Successfully",
                    icon: "success",
                    confirmButtonText: "Okay",
                    confirmButtonColor: "#830c81",
                    showCancelButton: false,
                  });
                  this.fullName = "";
                  this.emailAddress = "";
                  this.phone = "";
                  this.location = "";
                  this.whatAreYouLookingFor = "";
                  this.clearForm();
                  this.getGlobalFormData();
                  await this.getUpcomingEvents();
                }
              }
            }
          }

          // Share your story
          if (
            this.whatAreYouLookingFor === "Share Your Story/ Expertise with us"
          ) {
            Object.assign(payload, {
              whatAreYouLookingFor: this.whatAreYouLookingFor,
            });

            if (this.activeName === "Gentle_Warriors") {
              Object.assign(payload, {
                whatAreYouLookingForTabName: "Gentle Warriors",
              });

              const checkFields = [
                this.howLongHaveYoubeenInCaregiving_GW,
                this.relationshipWithThePersonYouAreCaringFor_GW,
                this.shortDescriptionOfYourself_GW,
              ];

              if (checkFields.every((f) => f.trim() === "")) {
                await this.$swal.fire({
                  text: "Please Fill Data",
                  icon: "waring",
                  confirmButtonText: "Okay",
                  confirmButtonColor: "#830c81",
                  showCancelButton: false,
                });
              } else {
                if (this.howLongHaveYoubeenInCaregiving_GW) {
                  Object.assign(payload, {
                    howLongHaveYoubeenInCaregiving_GW:
                      this.howLongHaveYoubeenInCaregiving_GW,
                  });
                }
                if (this.relationshipWithThePersonYouAreCaringFor_GW) {
                  Object.assign(payload, {
                    relationshipWithThePersonYouAreCaringFor_GW:
                      this.relationshipWithThePersonYouAreCaringFor_GW,
                  });
                }
                if (this.shortDescriptionOfYourself_GW) {
                  Object.assign(payload, {
                    shortDescriptionOfYourself_GW:
                      this.shortDescriptionOfYourself_GW,
                  });
                }

                let data = await this.$store.dispatch(
                  "globalForm/addglobalform",
                  payload
                );
                console.log(data, "Insert success");
                if (data) {
                  await this.$swal.fire({
                    text: "Form Submitted Successfully",
                    icon: "success",
                    confirmButtonText: "Okay",
                    confirmButtonColor: "#830c81",
                    showCancelButton: false,
                  });
                  this.fullName = "";
                  this.emailAddress = "";
                  this.phone = "";
                  this.location = "";
                  this.whatAreYouLookingFor = "";
                  this.clearForm();
                  this.getGlobalFormData();
                  await this.getUpcomingEvents();
                }
              }
            }
            if (this.activeName === "Caregiver_Diaries") {
              // Caregiver Diaries
              Object.assign(payload, {
                whatAreYouLookingForTabName: "Caregiver Diaries",
              });

              const checkFields = [
                this.howLongHaveYoubeenInCaregiving_CD,
                this.shortDescriptionOfYourself_CD,
              ];

              if (checkFields.every((f) => f.trim() === "")) {
                await this.$swal.fire({
                  text: "Please Fill Data",
                  icon: "waring",
                  confirmButtonText: "Okay",
                  confirmButtonColor: "#830c81",
                  showCancelButton: false,
                });
              } else {
                if (this.howLongHaveYoubeenInCaregiving_CD) {
                  Object.assign(payload, {
                    howLongHaveYoubeenInCaregiving_CD:
                      this.howLongHaveYoubeenInCaregiving_CD,
                  });
                }
                if (this.relationshipWithThePersonYouAreCaringFor_CD) {
                  Object.assign(payload, {
                    relationshipWithThePersonYouAreCaringFor_CD:
                      this.relationshipWithThePersonYouAreCaringFor_CD,
                  });
                }
                if (this.shortDescriptionOfYourself_CD) {
                  Object.assign(payload, {
                    shortDescriptionOfYourself_CD:
                      this.shortDescriptionOfYourself_CD,
                  });
                }
                let data = await this.$store.dispatch(
                  "globalForm/addglobalform",
                  payload
                );
                console.log(data, "Insert success");
                if (data) {
                  await this.$swal.fire({
                    text: "Form Submitted Successfully",
                    icon: "success",
                    confirmButtonText: "Okay",
                    confirmButtonColor: "#830c81",
                    showCancelButton: false,
                  });
                  this.fullName = "";
                  this.emailAddress = "";
                  this.phone = "";
                  this.location = "";
                  this.whatAreYouLookingFor = "";
                  this.clearForm();
                  this.getGlobalFormData();
                  await this.getUpcomingEvents();
                }
              }
            }
            if (this.activeName === "Compassionate_Caring") {
              // Compassionate Caring/ Humanising the Healers
              Object.assign(payload, {
                whatAreYouLookingForTabName:
                  "Compassionate Caring/ Humanising the Healers",
              });

              const checkFields = [
                // this.whichAreaDoYouRepresent,
                this.haveYouHadACaregivingExp,
                this.pleaseShareYourWebsiteorProfileUrl,
                this.shortDescriptionOfYourself_CC,
              ];

              if (
                checkFields.every((f) => f.trim() === "") &&
                this.whichAreaDoYouRepresent.length == 0
              ) {
                await this.$swal.fire({
                  text: "Please Fill Data",
                  icon: "waring",
                  confirmButtonText: "Okay",
                  confirmButtonColor: "#830c81",
                  showCancelButton: false,
                });
              } else {
                if (this.whichAreaDoYouRepresent) {
                  Object.assign(payload, {
                    whichAreaDoYouRepresent: this.whichAreaDoYouRepresent,
                  });
                }
                if (this.haveYouHadACaregivingExp) {
                  Object.assign(payload, {
                    haveYouHadACaregivingExp: this.haveYouHadACaregivingExp,
                  });
                }
                if (this.pleaseShareYourWebsiteorProfileUrl) {
                  Object.assign(payload, {
                    pleaseShareYourWebsiteorProfileUrl:
                      this.pleaseShareYourWebsiteorProfileUrl,
                  });
                }
                if (this.shortDescriptionOfYourself_CC) {
                  Object.assign(payload, {
                    shortDescriptionOfYourself_CC:
                      this.shortDescriptionOfYourself_CC,
                  });
                }

                let data = await this.$store.dispatch(
                  "globalForm/addglobalform",
                  payload
                );
                console.log(data, "Insert success");
                if (data) {
                  await this.$swal.fire({
                    text: "Form Submitted Successfully",
                    icon: "success",
                    confirmButtonText: "Okay",
                    confirmButtonColor: "#830c81",
                    showCancelButton: false,
                  });
                  this.fullName = "";
                  this.emailAddress = "";
                  this.phone = "";
                  this.location = "";
                  this.whatAreYouLookingFor = "";
                  this.clearForm();
                  this.getGlobalFormData();
                  await this.getUpcomingEvents();
                }
              }
            }
            if (this.activeName === "Print_Pictures") {
              // Print and Pictures
              Object.assign(payload, {
                whatAreYouLookingForTabName: "Print and Pictures",
              });

              const checkFields = [
                this.titleOfYourBookOrMovie,
                this.briefSummaryOfYourBookOrMovie,
                this.haveYouHadACaregivingExpYourself,
                this.shortDescriptionOfYourself_PP,
              ];

              if (checkFields.every((f) => f.trim() === "")) {
                await this.$swal.fire({
                  text: "Please Fill Data",
                  icon: "waring",
                  confirmButtonText: "Okay",
                  confirmButtonColor: "#830c81",
                  showCancelButton: false,
                });
              } else {
                if (this.titleOfYourBookOrMovie) {
                  Object.assign(payload, {
                    titleOfYourBookOrMovie: this.titleOfYourBookOrMovie,
                  });
                }
                if (this.briefSummaryOfYourBookOrMovie) {
                  Object.assign(payload, {
                    briefSummaryOfYourBookOrMovie:
                      this.briefSummaryOfYourBookOrMovie,
                  });
                }
                if (this.haveYouHadACaregivingExpYourself) {
                  Object.assign(payload, {
                    haveYouHadACaregivingExpYourself:
                      this.haveYouHadACaregivingExpYourself,
                  });
                }
                if (this.shortDescriptionOfYourself_PP) {
                  Object.assign(payload, {
                    shortDescriptionOfYourself_PP:
                      this.shortDescriptionOfYourself_PP,
                  });
                }
                let data = await this.$store.dispatch(
                  "globalForm/addglobalform",
                  payload
                );
                console.log(data, "Insert success");
                if (data) {
                  await this.$swal.fire({
                    text: "Form Submitted Successfully",
                    icon: "success",
                    confirmButtonText: "Okay",
                    confirmButtonColor: "#830c81",
                    showCancelButton: false,
                  });
                  this.fullName = "";
                  this.emailAddress = "";
                  this.phone = "";
                  this.location = "";
                  this.whatAreYouLookingFor = "";
                  this.clearForm();
                  this.getGlobalFormData();
                  await this.getUpcomingEvents();
                }
              }
            }
            if (this.activeName === "FFC") {
              // Future-Fit Corporates
              Object.assign(payload, {
                whatAreYouLookingForTabName: "Future-Fit Corporates",
              });

              const checkFields = [
                this.haveYouBeenInCaregivingRole,
                this.shortDescriptionOfYourself_FFC,
                this.pleaseMailYourProfileToProvideEmailId,
                this.pleaseShareYourLindedInProfile,
              ];

              if (checkFields.every((f) => f.trim() === "")) {
                await this.$swal.fire({
                  text: "Please Fill Data",
                  icon: "waring",
                  confirmButtonText: "Okay",
                  confirmButtonColor: "#830c81",
                  showCancelButton: false,
                });
              } else {
                if (this.haveYouBeenInCaregivingRole) {
                  Object.assign(payload, {
                    haveYouBeenInCaregivingRole:
                      this.haveYouBeenInCaregivingRole,
                  });
                }
                if (this.shortDescriptionOfYourself_FFC) {
                  Object.assign(payload, {
                    shortDescriptionOfYourself_FFC:
                      this.shortDescriptionOfYourself_FFC,
                  });
                }
                if (this.pleaseMailYourProfileToProvideEmailId) {
                  Object.assign(payload, {
                    pleaseMailYourProfileToProvideEmailId:
                      this.pleaseMailYourProfileToProvideEmailId,
                  });
                }
                if (this.pleaseShareYourLindedInProfile) {
                  Object.assign(payload, {
                    pleaseShareYourLindedInProfile:
                      this.pleaseShareYourLindedInProfile,
                  });
                }
                let data = await this.$store.dispatch(
                  "globalForm/addglobalform",
                  payload
                );
                console.log(data, "Insert success");
                if (data.code == 200) {
                  await this.$swal.fire({
                    text: "Form Submitted Successfully",
                    icon: "success",
                    confirmButtonText: "Okay",
                    confirmButtonColor: "#830c81",
                    showCancelButton: false,
                  });
                  this.fullName = "";
                  this.emailAddress = "";
                  this.phone = "";
                  this.location = "";
                  this.whatAreYouLookingFor = "";
                  this.clearForm();
                  this.getGlobalFormData();
                  await this.getUpcomingEvents();
                }
              }
            }
            if (this.activeName === "HC") {
              // Heart of Care
              // formData.append(
              //   "whatAreYouLookingFor",
              //   this.whatAreYouLookingFor
              // );
              Object.assign(payload, {
                whatAreYouLookingForTabName: "Heart of Care",
              });
              const checkFields = [
                // this.fullName,
                // this.emailAddress,
                // this.phone,
                // this.location,
                // this.typesOfArtwork,
                this.artworkDesp,
                // this.artWorkPermission,
                this.artworkUpload,
                // this.artworkUploadCoverImg,
              ];

              if (
                checkFields.every((f) => f.trim() === "") &&
                this.typesOfArtwork.length == 0
              ) {
                await this.$swal.fire({
                  text: "Please Fill Data",
                  icon: "waring",
                  confirmButtonText: "Okay",
                  confirmButtonColor: "#830c81",
                  showCancelButton: false,
                });
              } else {
                // formData.append("whatAreYouLookingForTabName", "Heart of Care");
                // formData.append("fullName", this.fullName);
                // formData.append("emailAddress", this.emailAddress);
                // formData.append("phone", this.phone);
                // formData.append("location", this.location);

                // formData.append("typesOfArtwork", this.typesOfArtwork);
                // formData.append("artworkDesp", this.artworkDesp);
                // formData.append("artWorkPermission", this.artWorkPermission);
                // formData.append("artworkUpload", this.artworkUploadCoverImg);
                // let data = await this.$store.dispatch(
                //   "globalForm/addglobalform",
                //   formData
                // );
                if (this.typesOfArtwork) {
                  Object.assign(payload, {
                    typesOfArtwork: this.typesOfArtwork,
                  });
                }
                if (this.artworkDesp) {
                  Object.assign(payload, {
                    artworkDesp: this.artworkDesp,
                  });
                }
                if (this.artWorkPermission) {
                  Object.assign(payload, {
                    artWorkPermission: this.artWorkPermission,
                  });
                }
                if (this.artworkUpload) {
                  Object.assign(payload, {
                    artworkUpload: this.artworkUpload,
                  });
                }
                let data = await this.$store.dispatch(
                  "globalForm/addglobalform",
                  payload
                );
                if (data.code == 200) {
                  await this.$swal.fire({
                    text: "Form Submitted Successfully",
                    icon: "success",
                    confirmButtonText: "Okay",
                    confirmButtonColor: "#830c81",
                    showCancelButton: false,
                  });
                  this.fullName = "";
                  this.emailAddress = "";
                  this.phone = "";
                  this.location = "";
                  this.whatAreYouLookingFor = "";
                  this.clearForm();
                  this.getGlobalFormData();
                  await this.getUpcomingEvents();
                }
              }
            }
          }

          // Other Issue
          if (this.whatAreYouLookingFor === "Other issue") {
            Object.assign(payload, {
              whatAreYouLookingFor: this.whatAreYouLookingFor,
            });

            if (
              this.otherIssues.length == 0 &&
              this.pleaseElaborateInDetailOnIssue == ""
            ) {
              await this.$swal.fire({
                text: "Please Fill Data",
                icon: "waring",
                confirmButtonText: "Okay",
                confirmButtonColor: "#830c81",
                showCancelButton: false,
              });
            } else {
              if (this.otherIssues.length) {
                Object.assign(payload, {
                  otherIssues: this.otherIssues,
                });
              }
              if (this.pleaseElaborateInDetailOnIssue) {
                Object.assign(payload, {
                  pleaseElaborateInDetailOnIssue:
                    this.pleaseElaborateInDetailOnIssue,
                });
              }
              let data = await this.$store.dispatch(
                "globalForm/addglobalform",
                payload
              );
              console.log(data, "Insert success");
              if (data) {
                await this.$swal.fire({
                  text: "Form Submitted Successfully",
                  icon: "success",
                  confirmButtonText: "Okay",
                  confirmButtonColor: "#830c81",
                  showCancelButton: false,
                });
                this.fullName = "";
                this.emailAddress = "";
                this.phone = "";
                this.location = "";
                this.whatAreYouLookingFor = "";
                this.clearForm();
                this.getGlobalFormData();
                await this.getUpcomingEvents();
              }
            }
          }

          // Register for Events
          if (this.whatAreYouLookingFor === "Register for Events") {
            Object.assign(payload, {
              whatAreYouLookingFor: this.whatAreYouLookingFor,
            });

            const checkFields = [
              this.eventType,
              //  this.eventUpcoming,
              this.eventDetails,
              this.eventFormat,
              this.eventRegistrationLink,
              this.eventVenue,
              this.eventLocation,
              this.eventDate,
              this.eventAddInformation,
            ];

            if (
              checkFields.every((f) => f.trim() === "") &&
              this.eventUpcoming.length == 0
            ) {
              await this.$swal.fire({
                text: "Please Fill Data",
                icon: "waring",
                confirmButtonText: "Okay",
                confirmButtonColor: "#830c81",
                showCancelButton: false,
              });
            } else {
              if (this.eventType) {
                Object.assign(payload, {
                  eventType: this.eventType,
                });
              }
              if (this.eventDetails) {
                Object.assign(payload, {
                  eventDetails: this.eventDetails,
                });
              }
              if (this.eventUpcoming) {
                for (let j = 0; j < this.eventUpcomingOptions.length; j++) {
                  if (this.eventUpcomingOptions[j]._id == this.eventUpcoming) {
                    Object.assign(payload, {
                      eventUpcoming: this.eventUpcomingOptions[j],
                    });
                  }
                }
              }
              if (this.eventFormat) {
                Object.assign(payload, {
                  eventFormat: this.eventFormat,
                });
              }
              if (this.eventRegistrationLink) {
                Object.assign(payload, {
                  eventRegistrationLink: this.eventRegistrationLink,
                });
              }
              if (this.eventVenue) {
                Object.assign(payload, {
                  eventVenue: this.eventVenue,
                });
              }
              if (this.eventLocation) {
                Object.assign(payload, {
                  eventLocation: this.eventLocation,
                });
              }
              if (this.eventDate) {
                Object.assign(payload, {
                  eventDate: this.eventDate,
                });
              }
              if (this.eventAddInformation) {
                Object.assign(payload, {
                  eventAddInformation: this.eventAddInformation,
                });
              }
              let data = await this.$store.dispatch(
                "globalForm/addglobalform",
                payload
              );
              console.log(data, "Insert success");
              if (data) {
                await this.$swal.fire({
                  text: "Form Submitted Successfully",
                  icon: "success",
                  confirmButtonText: "Okay",
                  confirmButtonColor: "#830c81",
                  showCancelButton: false,
                });
                this.fullName = "";
                this.emailAddress = "";
                this.phone = "";
                this.location = "";
                this.whatAreYouLookingFor = "";
                this.clearForm();
                this.getGlobalFormData();
                await this.getUpcomingEvents();
              }
            }
          }

          // Register for Programms
          if (this.whatAreYouLookingFor === "Register for Programmes") {
            Object.assign(payload, {
              whatAreYouLookingFor: this.whatAreYouLookingFor,
            });

            const checkFields = [
              this.programmeType,
              this.programmeDetails,
              this.programmeFormat,
              this.programmeRegistrationLink,
              this.programmeVenue,
              this.programmeLocation,
              this.programmeDate,
              this.programmeFee,
              this.programmeFeeAmount,
              this.programmeAddInformation,
            ];

            if (checkFields.every((f) => f.trim() === "")) {
              await this.$swal.fire({
                text: "Please Fill Data",
                icon: "waring",
                confirmButtonText: "Okay",
                confirmButtonColor: "#830c81",
                showCancelButton: false,
              });
            } else {
              if (this.programmeType) {
                Object.assign(payload, {
                  programmeType: this.programmeType,
                });
              }
              if (this.programmeDetails) {
                Object.assign(payload, {
                  programmeDetails: this.programmeDetails,
                });
              }
              if (this.programmeFormat) {
                Object.assign(payload, {
                  programmeFormat: this.programmeFormat,
                });
              }
              if (this.programmeRegistrationLink) {
                Object.assign(payload, {
                  programmeRegistrationLink: this.programmeRegistrationLink,
                });
              }
              if (this.programmeVenue) {
                Object.assign(payload, {
                  programmeVenue: this.programmeVenue,
                });
              }
              if (this.programmeLocation) {
                Object.assign(payload, {
                  programmeLocation: this.programmeLocation,
                });
              }
              if (this.programmeDate) {
                Object.assign(payload, {
                  programmeDate: this.programmeDate,
                });
              }
              if (this.programmeFee) {
                Object.assign(payload, {
                  programmeFee: this.programmeFee,
                });
              }
              if (this.programmeFeeAmount) {
                Object.assign(payload, {
                  programmeFeeAmount: this.programmeFeeAmount,
                });
              }
              if (this.programmeAddInformation) {
                Object.assign(payload, {
                  programmeAddInformation: this.programmeAddInformation,
                });
              }
              let data = await this.$store.dispatch(
                "globalForm/addglobalform",
                payload
              );
              console.log(data, "Insert success");
              if (data) {
                await this.$swal.fire({
                  text: "Form Submitted Successfully",
                  icon: "success",
                  confirmButtonText: "Okay",
                  confirmButtonColor: "#830c81",
                  showCancelButton: false,
                });
                this.fullName = "";
                this.emailAddress = "";
                this.phone = "";
                this.location = "";
                this.whatAreYouLookingFor = "";
                this.clearForm();
                this.getGlobalFormData();
                await this.getUpcomingEvents();
              }
            }
          }
        }
        // this.$refs["obs1"].reset();
        // this.$refs["obs1"].resetValidation();
      });
    },
    clearForm() {
      // mandatory fields
      // this.fullName= "";
      // this.emailAddress= "";
      // this.phone= "";
      // this.location= "";
      // this.whatAreYouLookingFor= "";
      // this.activeName = "Gentle_Warriors";
      // this.activeName2 = "Care_Services";
      // this.activeName3 = "Volunteer";

      // request for service
      this.requestForService = [];

      // corporate service/partnerships
      this.organisationName = "";
      this.officialEmail = "";
      this.designation = "";
      this.pleaseTellUsInBriefAboutOrg = "";
      this.websiteUrl = "";
      this.inWhatCapacityDoYouWishToPartnerWithUs = "";
      this.whatAreYourTop3Obj = "";

      //partner with us- Care Services
      this.companyName_CARE = "";
      this.companyAddress_CARE = "";
      this.companyWebsiteUrl_CARE = "";
      this.socialMediaUrl_CARE = "";
      this.yearsInBusiness_CARE = "";
      this.typesOfServices_CARE = [];
      this.additionalQuestions_CARE = "";

      //partner with us- Products
      this.companyName_PROD = "";
      this.companyAddress_PROD = "";
      this.companyWebsiteUrl_PROD = "";
      this.socialMediaUrl_PROD = "";
      this.yearsInBusiness_PROD = "";
      this.typesOfProducts_PROD = [];
      this.additionalQuestions_PROD = "";

      //partner with us- Collaboration
      this.companyName_COLLAB = "";
      this.companyAddress_COLLAB = "";
      this.companyWebsiteUrl_COLLAB = "";
      this.socialMediaUrl_COLLAB = "";
      this.yearsInBusiness_COLLAB = "";
      this.typesOfCollaboration_COLLAB = [];
      this.additionalQuestions_COLLAB = "";

      // partner with us-Care Attendent
      this.numofYearsInProfessions = "";
      this.currentCity = "";
      this.whyDoYouWantToPartnerWithCaregiverSaathi = "";

      // work with us-volunteer
      this.age = "";
      this.lastQualification = "";
      this.currentProfession = "";
      this.whatLanguagesDoYouSpeak = "";
      this.howMuchTimeCanYouGive = "";
      this.whichOfTheseSpecificAreasWouldYouLikeToWorkIn = "";
      this.haveYouBeenAVolunteerElseWhere = "";
      this.haveYouBeenAVolunteerElseWhere_Place = "";
      this.whatSkillsKnowledgesTalentsCanYouShare = "";
      this.whyDoesCaregiverSaathiAppealToYou = "";
      this.anyOtherInformation = "";
      // work with us-internships
      this.collegeORUniversityName = "";
      this.expectedGraduationYear = "";
      this.majorFieldOfStudy = "";
      this.preferredStartDateOfIntership = "";
      this.durationOfInternship = "";
      this.whichProjectAreYouInterestedIn = "";
      this.pleaseListRelevantSkillsThatMakeYouAStrongCandidate_Internship = "";
      this.whatAreTheTraitsThatYouAreProudoffAndWhatTraitsAreYouLookingToBuild_Internship =
        "";
      this.whatAreYourCareerAspirations_Internship = "";
      this.linkToResume_Internship = "";
      this.linkToVideo_Internship = "";

      // work with us-fellowships
      this.workExprience_Fellowship = "";
      this.lastDrawnSalary_Fellowship = "";
      this.qualification_Fellowship = "";
      this.preferredStartDate_Fellowship = "";
      this.whatAreTheTraitsThatYouAreProudoffAndWhatTraitsAreYouLookingToBuild_Fellowship =
        "";
      this.whatAreYourCareerAspirations_Fellowship = "";
      this.pleaseListRelevantSkillsThatMakeYouAStrongCandidate_Fellowship = "";
      this.linkToResume_Fellowship = "";
      this.linkToVideo_Fellowship = "";
      this.referencesFromPreviousJobName_Fellowship = "";
      this.referencesFromPreviousJobPhone_Fellowship = "";
      this.referencesFromPreviousJobEmail_Fellowship = "";

      // jobs
      this.positionAppliedFor = "";
      this.workExprience_Jobs = "";
      this.lastDrawnSalary_Jobs = "";
      this.qualification_Jobs = "";
      this.preferredStartDate_Jobs = "";
      this.whatAreTheTraitsThatYouAreProudoffAndWhatTraitsAreYouLookingToBuild_Jobs =
        "";
      this.whatAreYourCareerAspirations_Jobs = "";
      this.pleaseListRelevantSkillsThatMakeYouAStrongCandidate_Jobs = "";
      this.linkToResume_Jobs = "";
      this.linkToVideo_Jobs = "";
      this.referencesFromPreviousJobName_Jobs = "";
      this.referencesFromPreviousJobPhone_Jobs = "";
      this.referencesFromPreviousJobEmail_Jobs = "";

      // Share your Story/Expertise with us-Gentle Warriors (GW)
      this.howLongHaveYoubeenInCaregiving_GW = "";
      this.relationshipWithThePersonYouAreCaringFor_GW = "";
      this.shortDescriptionOfYourself_GW = "";

      // Share your Story/Expertise with us-Caregiver Diaries (CD)
      this.howLongHaveYoubeenInCaregiving_CD = "";
      this.relationshipWithThePersonYouAreCaringFor_CD = "";
      this.shortDescriptionOfYourself_CD = "";

      // Share your Story/Expertise with us-Compassionate Caring (CC)/Humanising the healers
      this.whichAreaDoYouRepresent = [];
      this.haveYouHadACaregivingExp = "";
      this.pleaseShareYourWebsiteorProfileUrl = "";
      this.shortDescriptionOfYourself_CC = "";

      // Share your Story/Expertise with us-Print and Pictures (PP)
      this.titleOfYourBookOrMovie = "";
      this.briefSummaryOfYourBookOrMovie = "";
      this.shortDescriptionOfYourself_PP = "";
      this.haveYouHadACaregivingExpYourself = "";

      // Share your Story/Expertise with us-Future Fit Corporate (FFC)
      this.haveYouBeenInCaregivingRole = "";
      this.shortDescriptionOfYourself_FFC = "";
      this.pleaseMailYourProfileToProvideEmailId = "";
      this.pleaseShareYourLindedInProfile = "";

      // Share your Story/Expertise with us-Heart of care
      this.typesOfArtwork = "";
      this.artworkDesp = "";
      this.artworkUpload = "";
      this.artWorkPermission = false;
      this.artworkUploadCoverImg = "";

      // others issues
      this.otherIssues = "";
      this.pleaseElaborateInDetailOnIssue = "";

      // Register for Events
      this.eventType = "";
      this.eventDetails = "";
      this.eventFormat = "";
      this.eventUpcoming = "";
      // online
      this.eventRegistrationLink = "";
      // ofline
      this.eventVenue = "";
      this.eventLocation = "";
      this.eventDate = "";
      this.eventAddInformation = "";

      // Register for Programmes
      this.programmeType = "";
      this.programmeDetails = "";
      this.programmeFormat = "";
      // online
      this.programmeRegistrationLink = "";
      // ofline
      this.programmeVenue = "";
      this.programmeLocation = "";
      this.programmeDate = "";
      this.programmeFee = "";
      this.programmeFeeAmount = "";
      this.programmeAddInformation = "";
    },
    capitalizeFirstLetter: function (str) {
      if (!str) return "";
      return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
    },
    handleSuccess(image) {
      console.log(image, "uploaded file");
      this.artworkUploadCoverImg = image;
      this.readerData(image);
    },
    handleRemove() {
      this.artworkUpload = null;
      this.artworkUploadCoverImg = null;
    },
    readerData(rawFile) {
      let loader = this.$loading();
      const reader = new FileReader();
      reader.onload = (e) => {
        this.$emit("load", (this.artworkUpload = e.target.result));
        loader.close();
      };
      reader.readAsDataURL(rawFile);
    },
    async updateLookingFor() {
      // Request for Service
      if (this.$route.params.pathName == "request-for-service") {
        this.whatAreYouLookingFor = "Request for Service";
      }
      // Corporate Service/ Partnership
      else if (this.$route.params.pathName == "corporate-service-partnership") {
        this.whatAreYouLookingFor = "Corporate Service/ Partnership";
      }
      // Partner with Us
      else if (this.$route.params.pathName == "partner-with-us") {
        this.whatAreYouLookingFor = "Partner with Us";
      }
      // Care Services
      else if (
        this.$route.params.pathName == "partner-with-us-as-care-services"
      ) {
        this.whatAreYouLookingFor = "Partner with Us";
        this.activeName2 = "Care_Services";
      }
      // Products
      else if (this.$route.params.pathName == "partner-with-us-as-products") {
        this.whatAreYouLookingFor = "Partner with Us";
        this.activeName2 = "Products";
      }
      // Collaboration
      else if (
        this.$route.params.pathName == "partner-with-us-as-collaboration"
      ) {
        this.whatAreYouLookingFor = "Partner with Us";
        this.activeName2 = "Collaboration";
      }
      // Care Attendent
      else if (
        this.$route.params.pathName == "partner-with-us-as-care-attendent"
      ) {
        this.whatAreYouLookingFor = "Partner with Us";
        this.activeName2 = "Care_Attendant";
      }
      // Work at CGS
      else if (this.$route.params.pathName == "work-at-cgs") {
        this.whatAreYouLookingFor = "Work at CGS";
      }
      // Volunteer
      else if (this.$route.params.pathName == "work-at-cgs-as-volunteer") {
        this.whatAreYouLookingFor = "Work at CGS";
        this.activeName3 = "Volunteer";
      }
      // Internship
      else if (this.$route.params.pathName == "work-at-cgs-as-internships") {
        this.whatAreYouLookingFor = "Work at CGS";
        this.activeName3 = "Interships";
      }
      // Jobs
      else if (this.$route.params.pathName == "work-at-cgs-as-jobs") {
        this.whatAreYouLookingFor = "Work at CGS";
        this.activeName3 = "Jobs";
      }
      // Fellowship
      else if (this.$route.params.pathName == "work-at-cgs-as-fellowships") {
        this.whatAreYouLookingFor = "Work at CGS";
        this.activeName3 = "Fellowships";
      }
      // Share Your Story/ Expertise with us
      else if (this.$route.params.pathName == "share-your-story-expertise") {
        this.whatAreYouLookingFor = "Share Your Story/ Expertise with us";
      }
      // Gentle Warriors
      else if (
        this.$route.params.pathName ==
        "share-your-story-expertise-gentle-warriors"
      ) {
        this.whatAreYouLookingFor = "Share Your Story/ Expertise with us";
        this.activeName = "Gentle_Warriors";
      }
      // Caregiver Diaries
      else if (
        this.$route.params.pathName ==
        "share-your-story-expertise-caregiver-diaries"
      ) {
        this.whatAreYouLookingFor = "Share Your Story/ Expertise with us";
        this.activeName = "Caregiver_Diaries";
      }
      // Compassionate_Caring
      else if (
        this.$route.params.pathName ==
        "share-your-story-expertise-compassionate-caring"
      ) {
        this.whatAreYouLookingFor = "Share Your Story/ Expertise with us";
        this.activeName = "Compassionate_Caring";
      }
      // Print_Pictures
      else if (
        this.$route.params.pathName ==
        "share-your-story-expertise-print-pictures"
      ) {
        this.whatAreYouLookingFor = "Share Your Story/ Expertise with us";
        this.activeName = "Print_Pictures";
      }
      // Future-Fit Corporates
      else if (
        this.$route.params.pathName == "share-your-story-expertise-ffc"
      ) {
        this.whatAreYouLookingFor = "Share Your Story/ Expertise with us";
        this.activeName = "FFC";
      }
      // Heart of Care
      else if (
        this.$route.params.pathName ==
        "share-your-story-expertise-heart-of-care"
      ) {
        this.whatAreYouLookingFor = "Share Your Story/ Expertise with us";
        this.activeName = "HC";
      }
      // Register for Events
      else if (this.$route.params.pathName == "register-for-events") {
        this.whatAreYouLookingFor = "Register for Events";
      }
      // Register for Programmes
      else if (this.$route.params.pathName == "register-for-programmes") {
        this.whatAreYouLookingFor = "Register for Programmes";
      }
      // Other issue
      else if (this.$route.params.pathName == "other-issue") {
        this.whatAreYouLookingFor = "Other issue";
      }
      // other tabs
      else if (
        this.$route.params.pathName == "corporate-services-customisedproject"
      ) {
        this.whatAreYouLookingFor = "Corporate Service/ Partnership";
        this.inWhatCapacityDoYouWishToPartnerWithUs = "Customised project";
      }
      // request for service want care attendent
      else if (
        this.$route.params.pathName == "request-for-service-want-care-attendent"
      ) {
        this.whatAreYouLookingFor = "Request for Service";
        this.requestForService.push("Want a care attendant");
      }
    },
  },
  async mounted() {
    // if (!!Object.keys(this.user).length) {
    //   this.email = this.user.email;
    //   this.firstName = `${this.user.firstname} ${this.user.lastname}`;
    // }

    try {
      if (this.user && this.user.firstname && this.user.lastname) {
        this.fullName = `${this.capitalizeFirstLetter(
          this.user.firstname
        )} ${this.capitalizeFirstLetter(this.user.lastname)}`;
      } else {
        this.fullName = "";
      }

      this.phone = this.user ? this.user.mobile : "";

      this.emailAddress = this.user ? this.user.email : "";
    } catch (error) {
      console.log(error);
    }
    await this.updateLookingFor();
    await this.getGlobalFormData();
    await this.getUpcomingEvents();
  },
  watch: {
    async "$route.params.pathName"(val) {
      await this.updateLookingFor();
      console.log("value for the for  the route changed", val);
    },
    // "$route.params.pathName": {
    //   handler(val) {
    //     console.log("Route changed to:", val);
    //     this.updateLookingFor();
    //   },
    //   // immediate: true,
    // },
  },
};
</script>

<style></style>
